import { AnyAction } from 'redux';
import {
  AktionsNachlass,
  App,
  BasisAdresse,
  BeziehungZumVn,
  FeatureToggles,
  FEVorvertragsnummer,
  FremdVNVorvertrag,
  IAnimalValueLabelElement,
  Immobilie,
  isMultistoreApp,
  JahresbeitragChanged,
  PersonensucheModal,
  Produktlinie,
  Regexps,
  StandaloneProdukt,
  StreckenGisDaten,
  TkvV2Vorbelegungdaten,
  ValueLabelElement,
  VnWechselAngaben,
  VnWechselVertraegeAendern,
  Vorbelegungdaten,
  Vorvertrag,
  VorvertragVorschaeden,
  VhvV2Vorbelegungdaten,
  VwgV2Vorbelegungdaten
} from '@ps20-frontend/frontend-models';
import { UnderwriterFragebogenCheckout, UwContextKey } from '@ps20-frontend/uw';
import {
  AnimalIllnesses,
  AvUpdateRequestModel,
  BankverbindungVorvertrag,
  BasicVertragsdaten,
  DokumentenErstellungRequestModel,
  EinstiegResponse,
  GegenstandCategoryModel,
  Kooperation,
  PersonensucheParty,
  PrometheusCounterIncreasePayload,
  Role,
  SalesProduktVariante,
  SofortschutzAvailableItem,
  SparteAntrag,
  SparteDruckdaten,
  TaasResponseModel,
  Tarifbereich,
  UpdateAvRequestModelForCap,
  Vermittlernummer,
  VorschlagDruckdaten,
  VorschlagDruckType
} from '@ps20/bff-models';
import { AxiosError } from 'axios';
import { Injectable } from '@angular/core';
import { v1 as uuidv1 } from 'uuid';
import {
  AddressvalidierungAction,
  AddressvorschlagAction,
  AddVertragToAngebote,
  AdressvorschlagFailedPayload,
  AdressvorschlagPayload,
  AngebotsId,
  AuthentificationSuccessful,
  BeginnAblaufGeaendert,
  CheckoutProdukt,
  CheckoutProduktAfterLoadAzam,
  CommonInsuranceData,
  DataForDashboard,
  DataForDashboardAfterLoadAzam,
  DeltafaktorenChanged,
  DoRequest,
  DoRequestResponse,
  DruckRequestPayload,
  DruckstatusEnum,
  ErrorPageContent,
  GesamtpreisChanged,
  GesamtpreisMitRabattChanged,
  GisDatenErmitteltPayload,
  HTTP_METHOD,
  ImmobilieUebernehmenPayload,
  InitializeShopPayload,
  KdvMetadaten,
  KuendigungenChanged,
  LoadVorvertraege,
  LogError,
  MasterProduktData,
  ModalCloseReason,
  ModalRequested,
  ModalType,
  NachlassReceived,
  NavigationRoute, OfferSavedWithCryptIdPayload,
  OwnedAngebotsId,
  PreiseForDashboard,
  PreiseStreckeErmittelt,
  PreisverzeichnisChanged,
  ProduktDeleted,
  ProduktRequested,
  ProvideStoreCreationDataPayload,
  ProvideVorhandeneVwgValidationPayload,
  ProvideVorvertragStatusValidationPayload,
  QuoteDbCheckoutPayload,
  QuoteDbDashboardPayload,
  QuoteDbInitPayload,
  QuoteDbRequestPayload,
  QuoteDbSpartePayload,
  QuoteDbToolbarPayload,
  RbdChanged,
  RbdMaxReceived,
  ReplaceState,
  RequestVorhandeneValidationPayload,
  RequestVorvertragStatusValidationPayload,
  ResponseType,
  RoleDeterminedPayload,
  SavedState,
  SavedStateWrapper,
  SetUnderwriterInfoPayload,
  Settings,
  ShowModal,
  SpeichernStatus,
  StreckenPricingFailed,
  StructuredRisikoortPayload,
  TaasNachlassVorteilReceivedPayload,
  TarifgenerationData,
  TgvEingabeTarget,
  TreuebonusChanged,
  TreuebonusMaxReceived,
  UpdateLoadedVorvertraege,
  VereinbarungenChanged,
  VermerkInfo,
  VertragslaufzeitChanged,
  VorbelegungPayload,
  VorschlagDruckClicked,
  VorschlagsdatenRequestPayload,
  VorteilsrabattPayload,
  VorversicherungAblaufdatumChanged,
  VorversicherungChanged,
  WrappedSavedStatesLoaded,
  ZaehlstueckeReceived,
  ZahlungsoptionenChanged,
} from './payload-models';
import { UnfallVPUbernehmenPayload } from './payload-models/unfallVpUebernehmen';
import { ZuschlagRisiko } from './payload-models/zuschlagRisiko';

export interface GlobalAction<T> extends AnyAction {
  payload?: T;
}

@Injectable()
export class GlobalActions {
  static readonly AUTHENTICATION_SUCCESSFUL = 'AUTHENTICATION_SUCCESSFUL';
  static readonly AUTHENTICATION_FAILED = 'AUTHENTICATION_FAILED';
  static readonly ANGEBOTS_ID_RECEIVED = 'ANGEBOTS_ID_RECEIVED';
  static readonly ANGEBOT_BERECHNEN_IN_DASHBOARD_CLICKED = 'ANGEBOT_BERECHNEN_IN_DASHBOARD_CLICKED';
  static readonly APP_HAS_BEEN_UPDATED = 'APP_HAS_BEEN_UPDATED';
  static readonly BFF_VERSION_UPDATED = 'BFF_VERSION_UPDATED';
  static readonly DO_REQUEST = 'DO_REQUEST';
  static readonly QUOTEDB_DATA_REQUESTED = 'QUOTEDB_DATA_REQUESTED';
  static readonly QUOTEDB_DASHBOARD_DATA_REQUESTED = 'QUOTEDB_DASHBOARD_DATA_REQUESTED';
  static readonly QUOTEDB_TOOLBAR_DATA_REQUESTED = 'QUOTEDB_TOOLBAR_DATA_REQUESTED';
  static readonly QUOTEDB_CHECKOUT_DATA_REQUESTED = 'QUOTEDB_CHECKOUT_DATA_REQUESTED';
  static readonly QUOTEDB_INIT = 'QUOTEDB_INIT';
  static readonly QUOTEDB_DATA_DASHBOARD_GENERATED = 'QUOTEDB_DATA_DASHBOARD_GENERATED';
  static readonly QUOTEDB_DATA_SPARTE_GENERATED = 'QUOTEDB_DATA_SPARTE_GENERATED';
  static readonly QUOTEDB_DATA_TOOLBAR_GENERATED = 'QUOTEDB_DATA_TOOLBAR_GENERATED';
  static readonly QUOTEDB_DATA_CHECKOUT_GENERATED = 'QUOTEDB_DATA_CHECKOUT_GENERATED';
  static readonly LOGGER_INITIALIZED = 'LOGGER_INITIALIZED';
  static readonly LOGGING_SUCCESSFUL = 'LOGGING_SUCCESSFUL';
  static readonly LOGGING_FAILED = 'AUTHENTICATION_FAILED';
  static readonly FEATURE_TOGGLE_RECEIVED = 'FEATURE_TOGGLE_RECEIVED';
  static readonly REGEXPS_RECEIVED = 'REGEXPS_RECEIVED';
  static readonly SETTINGS_RECEIVED = 'SETTINGS_RECEIVED';
  static readonly GESAMTPREIS_CHANGED = 'GESAMTPREIS_CHANGED';
  static readonly JAHREBEITRAG_CHANGED = 'JAHRESBEITRAG_CHANGED';
  static readonly ZAHLUNGSOPTIONEN_CHANGED = 'ZAHLUNGSOPTIONEN_CHANGED';
  static readonly ZAHLUNGSOPTIONEN_CHANGED_VORVERTRAG = 'ZAHLUNGSOPTIONEN_CHANGED_VORVERTRAG';
  static readonly TARIFIERUNG_TRIGGERED = 'TARIFIERUNG_TRIGGERED';
  static readonly TARIFIERUNG_TRIGGERED_BEIBEHALTUNG = 'TARIFIERUNG_TRIGGERED_BEIBEHALTUNG';
  static readonly TARIFIERUNG_HAS_STARTED = 'TARIFIERUNG_HAS_STARTED';
  static readonly TARIFIERUNG_HAS_ENDED = 'TARIFIERUNG_HAS_ENDED';
  static readonly TARIFIERUNG_CANCELED = 'TARIFIERUNG_CANCELED';
  static readonly TARIFIERUNG_RUN_RELEASED = 'TARIFIERUNG_RUN_RELEASED';
  static readonly STRECKEN_PRICING_FAILED = 'STRECKEN_PRICING_FAILED';
  static readonly ALL_TARIFIERUNGEN_HAVE_ENDED = 'ALL_TARIFIERUNGEN_HAVE_ENDED';
  static readonly PREISVERZEICHNIS_CHANGED = 'PREISVERZEICHNIS_CHANGED';
  static readonly LOAD_AV_REQUEST_SUCCESSFUL = 'LOAD_AV_REQUEST_SUCCESSFUL';
  static readonly LOAD_AV_REQUEST_FAILED = 'LOAD_AV_REQUEST_FAILED';
  static readonly SAVED_STATES_LOADED = 'SAVED_STATES_LOADED';
  static readonly UPDATE_LOADED_STATES = 'UPDATE_LOADED_STATES';
  static readonly LOCATION_CHANGED = 'LOCATION_CHANGED';
  static readonly NAVIGATION_COMPLETED = 'NAVIGATION_COMPLETED';
  static readonly NAVIGATION_REQUESTED = 'NAVIGATION_REQUESTED';
  static readonly NAVIGATE_TO_CHECKOUT_REQUESTED = 'NAVIGATE_TO_CHECKOUT_REQUESTED';
  static readonly ELEMENTARFRAGEBOGEN_PROVIDED = 'ELEMENTARFRAGEBOGEN_PROVIDED';
  static readonly PRODUKT_DELETED = 'PRODUKT_DELETED';
  static readonly PRODUKT_ACTION = 'PRODUKT_ACTION';
  static readonly PRODUKT_REQUESTED = 'PRODUKT_REQUESTED';
  static readonly PRODUKT_REQUESTED_AFTER_SAVE = 'PRODUKT_REQUESTED_AFTER_SAVE';
  static readonly PRODUKT_RECEIVED = 'PRODUKT_RECEIVED';
  static readonly PRODUKT_RECEIVED_AFTER_SAVE = 'PRODUKT_RECEIVED_AFTER_SAVE';
  static readonly PRODUKT_IN_MODAL = 'PRODUKT_IN_MODAL';
  static readonly ROLE_DETERMINED = 'ROLE_DETERMINED';
  static readonly SHOP_INIT = 'SHOP_INIT';
  static readonly SET_ACCESS_TOKEN = 'SET_ACCESS_TOKEN';
  static readonly SAVE_STATUS_RECEIVED = 'SAVE_STATUS_RECEIVED';
  static readonly OFFER_SAVED_WITH_CRYPTID = 'OFFER_SAVED_WITH_CRYPTID';
  static readonly UPDATE_DOCUMENTS_WITH_CRYPTID = 'UPDATE_DOCUMENTS_WITH_CRYPTID';
  static readonly SPEICHERN_REQUESTED = 'SPEICHERN_REQUESTED';
  static readonly ERROR_PAGE_REQUESTED = 'ERROR_PAGE_REQUESTED';
  static readonly CONSTRUCTION_PAGE_REQUESTED = 'CONSTRUCTION_PAGE_REQUESTED';
  static readonly MODAL_REQUESTED = 'GLOBAL_MODAL_REQUESTED';
  static readonly OPEN_FORWARDED_TO_UNDERWRITER_PAGE = 'OPEN_FORWARDED_TO_UNDERWRITER_PAGE';
  static readonly CLOSE_FORWARDED_TO_UNDERWRITER_PAGE = 'CLOSE_FORWARDED_TO_UNDERWRITER_PAGE';
  static readonly OPEN_MAP_VIEW_MODAL = 'OPEN_MAP_VIEW_MODAL';
  static readonly CLOSE_MAP_VIEW_MODAL = 'CLOSE_MAP_VIEW_MODAL';
  static readonly SHOW_MODAL = 'GLOBAL_SHOW_MODAL';
  static readonly CLOSE_MODAL = 'GLOBAL_CLOSE_MODAL';
  static readonly SHOP_MODAL_STATUS_REQUESTED = 'SHOP_MODAL_STATUS_REQUESTED';
  static readonly SHOP_MODAL_STATUS_RECIEVED = 'SHOP_MODAL_STATUS_RECIEVED';
  static readonly VERTRAGSLAUFZEIT_CHANGED = 'VERTRAGSLAUFZEIT_CHANGED';
  static readonly VORSCHLAGDATEN_REQUESTED = 'VORSCHLAGDATEN_REQUESTED';
  static readonly VORSCHLAGDATEN_GENERATED = 'VORSCHLAGDATEN_GENERATED';
  static readonly IMMOBILIE_UEBERNEHMEN = 'IMMOBILIE_UEBERNEHMEN';
  static readonly ADD_PRODUKT_TO_ANGEBOTE = 'ADD_PRODUKT_TO_ANGEBOTE';
  static readonly ADD_VORVERTRAG_TO_ANGEBOTE = 'ADD_VORVERTRAG_TO_ANGEBOTE';
  static readonly ADD_VORVERTRAG_TO_ANGEBOTE_REQUESTED = 'ADD_VORVERTRAG_TO_ANGEBOTE_REQUESTED';
  static readonly EINSTIEG_REQUEST_SUCCESSFUL = 'EINSTIEG_REQUEST_SUCCESSFUL';
  static readonly EINSTIEG_REQUEST_FAILED = 'EINSTIEG_REQUEST_FAILED';
  static readonly EINSTIEG_WITH_INVALID_ADDRESS = 'EINSTIEG_WITH_INVALID_ADDRESS';
  static readonly AMIS_IMMOBILIEN_TRANSFORMED = 'AMIS_IMMOBILIEN_TRANSFORMED';
  static readonly AMIS_CRM_IMMOBILIE_REQUESTED = 'AMIS_CRM_IMMOBILIE_REQUESTED';
  static readonly AMIS_CRM_IMMOBILIE_REQUEST_SUCCESSFUL = 'AMIS_CRM_IMMOBILIE_REQUEST_SUCCESSFUL';
  static readonly AMIS_CRM_IMMOBILIE_REQUEST_FAILED = 'AMIS_CRM_IMMOBILIE_REQUEST_FAILED';
  static readonly AMIS_CRM_PERSONENGRUPPE_REQUESTED = 'AMIS_CRM_PERSONENGRUPPE_REQUESTED';
  static readonly AMIS_CRM_PERSONENGRUPPE_REQUEST_SUCCESSFUL = 'AMIS_CRM_PERSONENGRUPPE_REQUEST_SUCCESSFUL';
  static readonly AMIS_CRM_PERSONENGRUPPE_REQUEST_FAILED = 'AMIS_CRM_PERSONENGRUPPE_REQUEST_FAILED';
  static readonly ADRESSDATEN_REQUEST_SUCCESSFUL = 'ADRESSDATEN_REQUEST_SUCCESSFUL';
  static readonly ADRESSDATEN_REQUEST_FAILED = 'ADRESSDATEN_REQUEST_FAILED';
  static readonly UPDATE_BEGINN_ABLAUF = 'UPDATE_BEGINN_ABLAUF';
  static readonly VORVERSICHERUNG_VORHANDEN_CHANGED = 'VORVERSICHERUNG_VORHANDEN_CHANGED';
  static readonly DELTAFAKTOREN_RECEIVED = 'DELTAFAKTOREN_RECEIVED';
  static readonly TARIFGENERATION_DATA_RECEIVED = 'TARIFGENERATION_DATA_RECEIVED';
  static readonly RBD_MAX_RECEIVED = 'RBD_MAX_RECEIVED';
  static readonly NACHLASS_RECEIVED = 'NACHLASS_RECEIVED';
  static readonly TREUEBONUS_MAX_RECEIVED = 'TREUEBONUS_MAX_RECEIVED';
  static readonly VEREINBARUNGEN_CHANGED = 'VEREINBARUNGEN_CHANGED';
  static readonly IN_DASHBOARD_UEBERNEHMEN = 'IN_DASHBOARD_UEBERNEHMEN';
  static readonly UPDATE_DASHBOARD_AFTER_LOAD_AZAM = 'UPDATE_DASHBOARD_AFTER_LOAD_AZAM';
  static readonly UPDATE_CHECKOUT_AFTER_LOAD_AZAM = 'UPDATE_CHECKOUT_AFTER_LOAD_AZAM';
  static readonly PREISE_INS_DASHBOARD_UEBERNEHMEN = 'PREISE_INS_DASHBOARD_UEBERNEHMEN';
  static readonly PREISE_RESET_DASHBOARD = 'PREISE_RESET_DASHBOARD';
  static readonly VORVERTRAG_BEIBEHALTEN = 'VORVERTRAG_BEIBEHALTEN';
  static readonly BEIBEHALTUNG_PRODUKT_REQUESTED = 'BEIBEHALTUNG_PRODUKT_REQUESTED';
  static readonly NEW_HASHED_TAAS_REQUEST = 'NEW_HASHED_TAAS_REQUEST';
  static readonly ANTRAGSNUMMER_GENERATED = 'GLOBAL_ANTRAGSNUMMER_GENERATED';
  static readonly ANTRAGSNUMMER_REQUESTED = 'GLOBAL_ANTRAGSNUMMER_REQUESTED';
  static readonly CREATE_STATE_SNAPSHOT = 'CREATE_STATE_SNAPSHOT';
  static readonly STATE_SNAPSHOT_CREATED = 'STATE_SNAPSHOT_CREATED';
  static readonly RESTORE_STATE_SNAPSHOT = 'RESTORE_STATE_SNAPSHOT';
  static readonly RESTORE_STATE_SNAPSHOT_FINISHED = 'RESTORE_STATE_SNAPSHOT_FINISHED';
  static readonly REPLACE_STATE = 'REPLACE_STATE';
  static readonly CREATE_STATE_SNAPSHOT_FOR_ALL_APPS = 'CREATE_STATE_SNAPSHOT_FOR_ALL_APPS';
  static readonly STATE_SNAPSHOT_FOR_ALL_APPS_CREATED = 'STATE_SNAPSHOT_FOR_ALL_APPS_CREATED';
  static readonly DRUCKDATEN_GENERATED = 'DRUCKDATEN_GENERATED';
  static readonly UPDATE_ZAEHLSTUECKE = 'UPDATE_ZAEHLSTUECKE';
  static readonly ZAEHLSTUECKE_RECEIVED = 'ZAEHLSTUECKE_RECEIVED';
  static readonly VERMERK_INIT = 'VERMERK_INIT';
  static readonly TOGGLE_MODAL = 'TOGGLE_MODAL';
  static readonly DRUCKDATEN_REQUESTED = 'DRUCKDATEN_REQUESTED';
  static readonly KDV_METADATEN_REQUESTED = 'KDV_METADATEN_REQUESTED';
  static readonly KDV_METADATEN_INIT = 'KDV_METADATEN_INIT';
  static readonly SPEICHERDATEN_REQUESTED = 'SPEICHERDATEN_REQUESTED';
  static readonly SPEICHERDATEN_REQUESTED_CAP = 'SPEICHERDATEN_REQUESTED_CAP';
  static readonly SPEICHERDATEN_GENERATED = 'SPEICHERDATEN_GENERATED';
  static readonly SPEICHERDATEN_GENERATED_CAP = 'SPEICHERDATEN_GENERATED_CAP';
  static readonly SOFORTSCHUTZ_AVAILABLE = 'SOFORTSCHUTZ_AVAILABLE';
  static readonly GET_ADDRESSVORSCHLAG = 'GET_ADDRESSVORSCHLAG';
  static readonly ADDRESSVORSCHLAG_SUCCESSFUL = 'ADDRESSVORSCHLAG_SUCCESSFUL';
  static readonly ADDRESSVORSCHLAG_FAILED = 'ADDRESSVORSCHLAG_FAILED';
  static readonly TARIFIERE_SHOP = 'TARIFIERE_SHOP';
  static readonly TARIFIERE_SHOP_SYNC = 'TARIFIERE_SHOP_SYNC';
  static readonly TARIFIERE_ANGEBOT_FOR_SHOP = 'TARIFIERE_APP_FOR_SHOP';
  static readonly UPDATE_SOFORTSCHUTZ_ACTIVE_FINISHED = 'UPDATE_SOFORTSCHUTZ_ACTIVE_FINISHED';
  static readonly VERSICHERUNGSBEGINN_CHANGED = 'VERSICHERUNGSBEGINN_CHANGED';
  static readonly RESET_BEGINN_ABLAUF = 'RESET_BEGINN_ABLAUF';
  static readonly UPDATE_SOFORTSCHUTZ_AVAILABLE = 'UPDATE_SOFORTSCHUTZ_AVAILABLE';
  static readonly TARIFIERE_SHOP_SUCCESS = 'TARIFIERE_SHOP_SUCCESS';
  static readonly CREATE_STRECKEN_SNAPSHOT = 'CREATE_STRECKEN_SNAPSHOT';
  static readonly RESTORE_STRECKEN_SNAPSHOT = 'RESTORE_STRECKEN_SNAPSHOT';
  static readonly UPDATE_SOFORTSCHUTZ_ACTIVE = 'UPDATE_SOFORTSCHUTZ_ACTIVE';
  static readonly TARIFIERE_SHOP_FAILED = 'TARIFIERE_SHOP_FAILED';
  static readonly TARIFIERE_SHOP_STALE = 'TARIFIERE_SHOP_STALE';
  static readonly ANGEBOTE_IN_WARENKORB_REQUESTED = 'APPIDS_IN_WARENKORB_REQUESTED';
  static readonly ANGEBOTE_IN_WARENKORB_PROVIDED = 'APPIDS_IN_WARENKORB_PROVIDED';
  static readonly BEIBEHALTENE_ANGEBOTE_IN_WARENKORB_PROVIDED =
    'BEIBEHALTENE_ANGEBOTE_IN_WARENKORB_PROVIDED';
  static readonly REQUEST_MULTIANGEBOT_VWG_ADRESS_VALIDATION = 'REQUEST_MULTIANGEBOT_VWG_ADRESS_VALIDATION';
  static readonly PROVIDE_MULTIANGEBOT_ADRESS_VALIDATION = 'PROVIDE_MULTIANGEBOT_ADRESS_VALIDATION';
  static readonly REQUEST_VORVERTRAG_STATUS_VALIDATION = 'REQUEST_VORVERTRAG_STATUS_VALIDATION';
  static readonly PROVIDE_VORVERTRAG_STATUS_VALIDATION = 'PROVIDE_VORVERTRAG_STATUS_VALIDATION';
  static readonly STRUCTURED_RISIKOORT_REQUESTED = 'STRUCTURED_RISIKOORT_REQUESTED';
  static readonly STRUCTURED_RISIKOORT_PROVIDED = 'STRUCTURED_RISIKOORT_PROVIDED';
  static readonly VORVERSICHERUNG_ABLAUFDATUM_CHANGED = 'VORVERSICHERUNG_ABLAUFDATUM_CHANGED';
  static readonly LOG_ERROR = 'LOG_ERROR';
  static readonly PREISE_STRECKE_ERMITTELT = 'PREISE_STRECKE_ERMITTELT';
  static readonly GISDATEN_ERMITTELT = 'GISDATEN_ERMITTELT';
  static readonly VORVERTRAG_VORSCHAEDEN_ERMITTELT = 'VORVERTRAG_VORSCHAEDEN_ERMITTELT';
  static readonly GESAMTPREIS_MIT_RABATT_CHANGED = 'GESAMTPREIS_MIT_RABATT_CHANGED';
  static readonly SHOP_TARIFIERUNG_BAUSTEINPREISE_CHANGED = 'SHOP_TARIFIERUNG_BAUSTEINPREISE_CHANGED';
  static readonly UNFALL_ZAEHLSTUECKE_CHANGED = 'UNFALL_ZAEHLSTUECKE_CHANGED';
  static readonly ADRESSE_VALIDIEREN = 'ADRESSE_VALIDIEREN';
  static readonly ADRESSE_VALIDIEREN_REQUEST_SUCCESSFULL = 'ADRESSE_VALIDIEREN_REQUEST_SUCCESSFULL';
  static readonly ADRESSE_VALIDIEREN_REQUEST_FAILED = 'ADRESSE_VALIDIEREN_REQUEST_ERROR';
  static readonly ADRESSE_VALIDIEREN_SUCCESSFULL = 'ADRESSE_VALIDIEREN_SUCCESSFULL';
  static readonly ADRESSE_VALIDIEREN_FAILED = 'ADRESSE_VALIDIEREN_FAILED';
  static readonly LOAD_VORVERTRAEGE = 'LOAD_VORVERTRAEGE';
  static readonly UPDATE_VORVERTRAEGE = 'UPDATE_VORVERTRAEGE';
  static readonly UPDATE_VORVERTRAEGE_FAILED = 'UPDATE_VORVERTRAEGE_FAILED';
  static readonly VORVERTRAEGE_LOAD_FINISHED = 'VORVERTRAEGE_LOAD_FINISHED';
  static readonly VORSCHLAG_DRUCK_CLICKED = 'VORSCHLAG_DRUCK_CLICKED';
  static readonly VORSCHLAG_DRUCKEN_ERROR = 'VORSCHLAG_DRUCKEN_ERROR';
  static readonly VORSCHLAG_DRUCKEN_SUCCESS = 'VORSCHLAG_DRUCKEN_SUCCESS';
  static readonly VORSCHLAG_DRUCK_DATEN_REQUESTED = 'VORSCHLAG_DRUCK_DATEN_REQUESTED';
  static readonly VORSCHLAG_DRUCK_DATEN_GENERATED = 'VORSCHLAG_DRUCK_DATEN_GENERATED';
  static readonly VORBELEGUNG_REQUESTED = 'VORBELEGUNG_REQUESTED';
  static readonly VORBELEGUNG_FINISHED = 'VORBELEGUNG_FINISHED';
  static readonly THH_PFERD_VORBELEGUNG_FINISHED = 'THH_PFERD_VORBELEGUNG_FINISHED';
  static readonly THH_HUND_VORBELEGUNG_FINISHED = 'THH_HUND_VORBELEGUNG_FINISHED';
  static readonly VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED = 'VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED';
  static readonly CHANGE_RELEVANT_RISKDATA_HASH = 'CHANGE_RELEVANT_RISKDATA_HASH';
  static readonly TARIFBEREICH_CHANGED = 'TARIFBEREICH_CHANGED';
  static readonly ASSEKURANZTARIF_CHANGED = 'ASSEKURANZTARIF_CHANGED';
  static readonly ASSEKURANZTARIF_CHANGED_VORVERTRAG = 'ASSEKURANZTARIF_CHANGED_VORVERTRAG';
  static readonly ASSEKURANZTARIF_MIXED = 'ASSEKURANZTARIF_MIXED';
  static readonly ASSEKURANZTARIF_VORBELEGT = 'ASSEKURANZTARIF_VORBELEGT';
  static readonly UPDATE_ASSEKURANZTARIF_DATA = 'UPDATE_ASSEKURANZTARIF_DATA';
  static readonly UPDATE_ASSEKURANZTARIF_DATA_AFTER_VV_LOAD = 'UPDATE_ASSEKURANZTARIF_DATA_AFTER_VV_LOAD';
  static readonly RABATT_HINWEIS_CHANGED = 'RABATT_HINWEIS_CHANGED';
  static readonly VORTEILS_RABATT_HINWEIS_CHANGED = 'VORTEILS_RABATT_HINWEIS_CHANGED';
  static readonly OUT_OF_DELTA_RANGE = 'OUT_OF_DELTA_RANGE';
  static readonly HUNDERASSENLISTE_RETRIEVED = 'HUNDERASSEN_LISTE_RETRIEVED';
  static readonly THH_HUNDERASSEN_LISTE_RETRIEVED = 'THH_HUNDERASSEN_LISTE_RETRIEVED';
  static readonly PFERDERASSEN_LISTE_RETRIEVED = 'PFERDERASSEN_LISTE_RETRIEVED';
  static readonly THH_PFERDERASSEN_LISTE_RETRIEVED = 'THH_PFERDERASSEN_LISTE_RETRIEVED';
  static readonly KATZENRASSEN_LISTE_RETRIEVED = 'KATZENRASSEN_LISTE_RETRIEVED';
  static readonly ANIMAL_ILLNESSES_RECEIVED = 'ANIMAL_ILLNESSES_RECEIVED';
  static readonly COMMON_INSURANCE_DATA_RECEIVED = 'COMMON_INSURANCE_DATA_RECEIVED';
  static readonly INITIAL_STORE_MANAGEMENT_DATA_REQUESTED = 'INITIAL_STORE_MANAGEMENT_DATA_REQUESTED';
  static readonly INITIAL_STORE_MANAGEMENT_DATA_PROVIDED = 'INITIAL_STORE_MANAGEMENT_DATA_PROVIDED';
  static readonly ALL_MISSING_STORES_CREATED = 'ALL_MISSING_STORES_CREATED';
  static readonly TIERGRUPPE_ANGEBOT_EDIT_REQUESTED = 'TIERGRUPPE_ANGEBOT_EDIT_REQUESTED';
  static readonly TIERGRUPPE_EINGABE_TARGET_SET = 'TIERGRUPPE_EINGABE_TARGET_SET';
  static readonly TIERGRUPPE_UEBERNOMMEN = 'TIERGRUPPE_UEBERNOMMEN';
  static readonly TIERGRUPPE_TAKE_OVER_STARTED = 'TIERGRUPPE_TAKE_OVER_STARTED';
  static readonly TIERGRUPPE_TAKE_OVER_ENDED = 'TIERGRUPPE_TAKE_OVER_ENDED';
  static readonly OWNED_STORE_INITIALIZED = 'OWNED_STORE_INITIALIZED';
  static readonly SET_PRICE_GUARANTEE = 'SET_PRICE_GUARANTEE';
  static readonly VN_WECHSEL_DATA_REQUESTED = 'VN_WECHSEL_DATA_REQUESTED';
  static readonly VN_WECHSEL_DATA_PROVIDED = 'VN_WECHSEL_DATA_PROVIDED';
  static readonly VN_WECHSEL_CHANGED = 'VN_WECHSEL_CHANGED';
  static readonly UPDATE_ABGELAUFENER_VERSICHERUNGSBEGINN = 'UDATE_ABGELAUFENE_VERSICHERUNGS_BEGINN';
  static readonly UPDATE_ABGELAUFENER_VERSICHERUNGSBEGINN_FAILED =
    'UDATE_ABGELAUFENE_VERSICHERUNGS_BEGINN_FAILED';
  static readonly UPDATE_ABGELAUFENER_VERSICHERUNGSBEGINN_SUCCESS =
    'UDATE_ABGELAUFENE_VERSICHERUNGS_BEGINN_SUCCESS';
  static readonly UPDATE_BEGINN_ABLAUF_OF_PRODUKTE = 'UPDATE_BEGINN_ABLAUF_OF_PRODUKTE';
  static readonly REQUEST_VERMITTLERNUMMER = 'REQUEST_VERMITTLERNUMMER';
  static readonly PROVIDE_VERMITTLERNUMMER = 'PROVIDE_VERMITTLERNUMMER';
  static readonly INITIAL_HAUPTFAELLIGKEIT_REQUESTED = 'INITIAL_HAUPTFAELLIGKEIT_REQUESTED';
  static readonly HAUPTFAELLIGKEIT_CHANGED = 'HAUPTFAELLIGKEIT_CHANGED';
  static readonly HAUPTFAELLIGKEIT_JHP_CHANGED = 'HAUPTFAELLIGKEIT_JHP_CHANGED';
  static readonly MINDESTVERTRAGSLAUFZEIT_CHECKBOX_CHANGED = 'MINDESTVERTRAGSLAUFZEIT_CHECKBOX_CHANGED';
  static readonly USER_LOGGED_OUT = 'USER_LOGGED_OUT';
  static readonly VN_WECHSEL_GRUND_CHANGED = 'VN_WECHSEL_GRUND_CHANGED';

  static readonly UPDATE_BEGINN_ABLAUF_OF_LOADED_STATE = 'UPDATE_BEGINN_ABBLAUF_OF_LOADED_STATE';
  static readonly INCREASE_PROMETHEUS_COUNTER = 'INCREASE_PROMETHEUS_COUNTER';
  static readonly CHECK_VORVERTRAEGE = 'CHECK_VORVERTRAEGE';

  static readonly DASHBOARD_UNFALL_VP_UEBERNEHMEN = 'DASHBOARD_UNFALL_VP_UEBERNEHMEN';
  static readonly TOGGLE_PERSONENSUCHE_MODAL = 'TOGGLE_PERSONENSUCHE_MODAL';

  static readonly VERMITTLER_NUMMER_CHANGED = 'VERMITTLER_NUMMER_CHANGED';
  static readonly VERMITTLER_BNRB_CHANGED = 'VERMITTLER_BNRB_CHANGED';
  static readonly VERMITTLER_FREMD_CHANGED = 'VERMITTLER_FREMD_CHANGED';

  static readonly GEGENSTAENDE_CATEGORIES_RECEIVED = 'GEGENSTAENDE_CATEGORIES_RECEIVED';

  static readonly UPDATE_AKTIONSNACHLASS_CODE = 'UPDATE_AKTIONSNACHLASS_CODE';
  static readonly CHECK_VALID_AKTIONSNACHLASS_CODE = 'CHECK_VALID_AKTIONSNACHLASS_CODE';
  static readonly OBJEKT_MIT_AUSLAENDISCHE_ADRESSE_ADDED = 'OBJEKT_MIT_AUSLAENDISCHE_ADRESSE_ADDED';
  static readonly AUSLAENDISCHE_ADRESSE_ANGEBOT_REMOVED = 'AUSLAENDISCHE_ADRESSE_AGEBOT_REMOVED';
  static readonly ASSEKURANZ_BEZIEHUNG_CHANGED = 'ASSEKURANZ_BEZIEHUNG_CHANGED';
  static readonly KOOPERATIONEN_LIST_RECEIVED = 'KOOPERATIONEN_LIST_RECEIVED';
  static readonly UPDATE_SOFORTSCHUTZ_END_DATE = 'UPDATE_SOFORTSCHUTZ_END_DATE';
  static readonly INTERNER_VERTRAGSBEZUG_RECEIVED = 'INTERNER_VERTRAGSBEZUG_RECEIVED';
  static readonly TAAS_NACHLASS_RABATT_RECEIVED = 'TAAS_NACHLASS_RABATT_RECEIVED';
  static readonly SAVED_DOKUMENTID_RECEIVED = 'SAVED_DOKUMENTID_RECEIVED';
  static readonly UPDATE_RECEIVED_VORTEILNACHLASS = 'UPDATE_RECEIVED_VORTEILNACHLASS';
  static readonly UPDATE_RISIKOORT_ZUERSZONE = 'UPDATE_RISIKOORT_ZUERSZONE';
  static readonly ZUSCHLAGRISIKO_RECEIVED = 'ZUSCHLAGRISIKO_RECEIVED';
  static readonly ZUSCHLAEGEFAKTOR_RECEIVED = 'ZUSCHLAEGEFAKTOR_RECEIVED';
  static readonly ZUERS_ZONE_RECEIVED = 'ZUERS_ZONE_RECEIVED';
  static readonly SET_UNDERWRITER_INFO = 'SET_UNDERWRITER_INFO';
  static readonly SET_ANFRAGEPFLICHTIGE_INFORMATIONEN = 'SET_ANFRAGEPFLICHTIGE_INFORMATIONEN';
  static readonly SET_SHOW_TRANSFER_TO_AGENT_PAGE = 'SET_SHOW_TRANSFER_TO_AGENT_PAGE';
  static readonly SET_EDITING_UW_APPROVED_OFFER = 'SET_EDITING_UW_APPROVED_OFFER';
  static readonly SET_NEEDS_UW_RESUBMISSION = 'SET_NEEDS_UW_RESUBMISSION';
  static readonly UW_RESUBMISSION_FULFILLED_ANGEBOTE_COLLECTED = 'UW_RESUBMISSION_FULFILLED_ANGEBOTE_COLLECTED';
  static readonly SET_UW_REVIEW_BLOCKS_EDITING = 'SET_UW_REVIEW_BLOCKS_EDITING';
  static readonly CONFIRM_UW_APPROVED_OFFER_EDITION = 'CONFIRM_UW_APPROVED_OFFER_EDITION';
  static readonly EINZELWERTE_CHANGED = 'EINZELWERTE_CHANGED';

  addObjektMitAuslaendischeAdresse(
    containsAuslaendischeAdresse: boolean,
    appId: App,
    angebotsId: string,
  ): GlobalAction<AngebotsId> {
    return {
      type: GlobalActions.OBJEKT_MIT_AUSLAENDISCHE_ADRESSE_ADDED,
      payload: {
        appId: appId,
        angebotsId: angebotsId,
        containsAuslaendischeAdresse: containsAuslaendischeAdresse,
      },
    };
  }

  removeObjectWithAuslaendischeAdresse(appId: App, angebotsId: string): GlobalAction<AngebotsId> {
    return {
      type: GlobalActions.AUSLAENDISCHE_ADRESSE_ANGEBOT_REMOVED,
      payload: {
        appId: appId,
        angebotsId: angebotsId,
      },
    };
  }

  increasePrometheusCounter(
    counters: Array<PrometheusCounterIncreasePayload>,
  ): GlobalAction<Array<PrometheusCounterIncreasePayload>> {
    return {
      type: GlobalActions.INCREASE_PROMETHEUS_COUNTER,
      payload: counters,
    };
  }

  vnWechselChanged(
    vnWechselAngabenElement: VnWechselVertraegeAendern,
  ): GlobalAction<VnWechselVertraegeAendern> {
    return {
      type: GlobalActions.VN_WECHSEL_CHANGED,
      payload: vnWechselAngabenElement,
    };
  }

  commonInsuranceDataReceived(commonData: CommonInsuranceData): GlobalAction<CommonInsuranceData> {
    return {
      type: GlobalActions.COMMON_INSURANCE_DATA_RECEIVED,
      payload: commonData,
    };
  }

  angebotBerechnenInDashboardClicked(payload: AngebotsId): GlobalAction<AngebotsId> {
    return {
      type: GlobalActions.ANGEBOT_BERECHNEN_IN_DASHBOARD_CLICKED,
      payload,
    };
  }

  angebotsIdReceived(angebotsId?: string): GlobalAction<string> {
    return { type: GlobalActions.ANGEBOTS_ID_RECEIVED, payload: angebotsId };
  }

  vorschlagDruckClicked(
    gesamtbeitrag: number,
    vorschlagType?: VorschlagDruckType,
  ): GlobalAction<VorschlagDruckClicked> {
    return {
      type: GlobalActions.VORSCHLAG_DRUCK_CLICKED,
      payload: { gesamtbeitragAllerSparten: gesamtbeitrag, vorschlagType },
    };
  }

  vorschlagDruckenError(status: DruckstatusEnum): GlobalAction<DruckstatusEnum> {
    return { type: GlobalActions.VORSCHLAG_DRUCKEN_ERROR, payload: status };
  }

  vorschlagdruckdatenRequested(gesamtbeitragAllerSparten: number): GlobalAction<number> {
    return {
      type: GlobalActions.VORSCHLAG_DRUCK_DATEN_REQUESTED,
      payload: gesamtbeitragAllerSparten,
    };
  }

  vorschlagdruckdatenGenerated(
    vorschlagsdruckdaten: DokumentenErstellungRequestModel<VorschlagDruckdaten>,
  ): GlobalAction<DokumentenErstellungRequestModel<VorschlagDruckdaten>> {
    return {
      type: GlobalActions.VORSCHLAG_DRUCK_DATEN_GENERATED,
      payload: vorschlagsdruckdaten,
    };
  }

  antragsnummerRequested(appId: App, angebotsId?: string): GlobalAction<AngebotsId> {
    return {
      type: GlobalActions.ANTRAGSNUMMER_REQUESTED,
      payload: { appId, angebotsId },
    };
  }

  getAdressvorschlag(payload: AddressvorschlagAction): GlobalAction<AddressvorschlagAction> {
    return {
      type: GlobalActions.GET_ADDRESSVORSCHLAG,
      payload,
    };
  }

  adressvorschlaegeFailed(
    payload: AdressvorschlagFailedPayload,
  ): GlobalAction<AdressvorschlagFailedPayload> {
    return {
      type: GlobalActions.ADDRESSVORSCHLAG_FAILED,
      payload,
    };
  }

  adressvorschlaegeReceived(
    response: AdressvorschlagPayload,
  ): GlobalAction<AdressvorschlagPayload> {
    return {
      type: GlobalActions.ADDRESSVORSCHLAG_SUCCESSFUL,
      payload: response,
    };
  }

  adresseValidieren(payload: AddressvalidierungAction): GlobalAction<AddressvalidierungAction> {
    return {
      type: GlobalActions.ADRESSE_VALIDIEREN,
      payload,
    };
  }

  adresseValidierenSuccess(): GlobalAction<undefined> {
    return {
      type: GlobalActions.ADRESSE_VALIDIEREN_SUCCESSFULL,
    };
  }

  adresseValidierenFailed(): GlobalAction<undefined> {
    return {
      type: GlobalActions.ADRESSE_VALIDIEREN_FAILED,
    };
  }

  authenticationSuccessful(
    authentificationSuccessful: AuthentificationSuccessful,
  ): GlobalAction<AuthentificationSuccessful> {
    return {
      type: GlobalActions.AUTHENTICATION_SUCCESSFUL,
      payload: authentificationSuccessful,
    };
  }

  authenticationFailed(reason: string): GlobalAction<string> {
    return {
      type: GlobalActions.AUTHENTICATION_FAILED,
      payload: reason,
    };
  }

  appHasBeenUpdated(changedApp: App): GlobalAction<App> {
    return {
      type: GlobalActions.APP_HAS_BEEN_UPDATED,
      payload: changedApp,
    };
  }

  featuretoggleReceived(featuretoggles: FeatureToggles): GlobalAction<FeatureToggles> {
    return {
      type: GlobalActions.FEATURE_TOGGLE_RECEIVED,
      payload: featuretoggles,
    };
  }

  regexpsReceived(regexps: Regexps): GlobalAction<Regexps> {
    return {
      type: GlobalActions.REGEXPS_RECEIVED,
      payload: regexps,
    };
  }

  settingsReceived(settings: Settings): GlobalAction<Settings> {
    return {
      type: GlobalActions.SETTINGS_RECEIVED,
      payload: settings,
    };
  }

  vorversicherungVorhandenChanged(
    vorversicherungChanged: VorversicherungChanged,
  ): GlobalAction<VorversicherungChanged> {
    return {
      type: GlobalActions.VORVERSICHERUNG_VORHANDEN_CHANGED,
      payload: vorversicherungChanged,
    };
  }

  vertragslaufzeitAusgewaehlt(
    vertragslaufzeitPayload: VertragslaufzeitChanged,
  ): GlobalAction<VertragslaufzeitChanged> {
    return {
      type: GlobalActions.VERTRAGSLAUFZEIT_CHANGED,
      payload: vertragslaufzeitPayload,
    };
  }

  updateBeginnAblauf(data: UpdateBeginnAblaufPayload): UpdateBeginnAblaufAction {
    return { type: GlobalActions.UPDATE_BEGINN_ABLAUF, payload: data };
  }

  updateAbgelaufeneVersicherungsbeginn(): GlobalAction<undefined> {
    return { type: GlobalActions.UPDATE_ABGELAUFENER_VERSICHERUNGSBEGINN };
  }

  updateBeginnAblaufOfLoadedState(): GlobalAction<undefined> {
    return { type: GlobalActions.UPDATE_BEGINN_ABLAUF_OF_LOADED_STATE };
  }

  updateAbgelaufeneVersicherungsbeginnFailed(): GlobalAction<undefined> {
    return {
      type: GlobalActions.UPDATE_ABGELAUFENER_VERSICHERUNGSBEGINN_FAILED,
    };
  }

  updateAbgelaufeneVersicherungsbeginnSuccessfull(): GlobalAction<undefined> {
    return {
      type: GlobalActions.UPDATE_ABGELAUFENER_VERSICHERUNGSBEGINN_SUCCESS,
    };
  }

  updateBeginnAblaufOfProdukte(
    payload: BeginnAblaufGeaendert[],
  ): GlobalAction<BeginnAblaufGeaendert[]> {
    return { type: GlobalActions.UPDATE_BEGINN_ABLAUF_OF_PRODUKTE, payload };
  }

  gesamtpreisChanged(
    gesamtpreis: number,
    showGesamtpreisInfo: boolean,
    triggeredByApp: App,
    angebotsId?: string,
  ): GlobalAction<GesamtpreisChanged> {
    return {
      type: GlobalActions.GESAMTPREIS_CHANGED,
      payload: { gesamtpreis, showGesamtpreisInfo, triggeredByApp, angebotsId },
    };
  }

  gesamtpreisMitRabattChanged(
    gesamtpreisMitRabatt: number,
  ): GlobalAction<GesamtpreisMitRabattChanged> {
    return {
      type: GlobalActions.GESAMTPREIS_MIT_RABATT_CHANGED,
      payload: { gesamtpreisMitRabatt },
    };
  }

  shopTarifierungBausteinpreiseChanged(
    bausteinPreisListe: SalesProduktVariante['bausteinPreise'],
  ): GlobalAction<SalesProduktVariante['bausteinPreise']> {
    return {
      type: GlobalActions.SHOP_TARIFIERUNG_BAUSTEINPREISE_CHANGED,
      payload: bausteinPreisListe,
    };
  }

  // wird nur lokal geschmissen
  jahresbeitragChanged(jahresbeitraege: JahresbeitragChanged): GlobalAction<JahresbeitragChanged> {
    return {
      type: GlobalActions.JAHREBEITRAG_CHANGED,
      payload: jahresbeitraege,
    };
  }

  checkVorvertraege(): GlobalAction<void> {
    return { type: GlobalActions.CHECK_VORVERTRAEGE };
  }

  tarifierungHasStarted(): GlobalAction<void> {
    return { type: GlobalActions.TARIFIERUNG_HAS_STARTED };
  }

  tarifierungHasEnded(): GlobalAction<void> {
    return { type: GlobalActions.TARIFIERUNG_HAS_ENDED };
  }

  tarifierungHasCancelled(): GlobalAction<void> {
    return { type: GlobalActions.TARIFIERUNG_CANCELED };
  }

  tarifierungRunReleased(): GlobalAction<void> {
    return { type: GlobalActions.TARIFIERUNG_RUN_RELEASED };
  }

  streckenPricingFailed(payload: StreckenPricingFailed): GlobalAction<StreckenPricingFailed> {
    return { type: GlobalActions.STRECKEN_PRICING_FAILED, payload };
  }

  allTarifierungenHaveEnded(): GlobalAction<void> {
    return { type: GlobalActions.ALL_TARIFIERUNGEN_HAVE_ENDED };
  }

  zahlungsoptionenChanged(
    zahlungsoptionenChanged: ZahlungsoptionenChanged,
  ): GlobalAction<ZahlungsoptionenChanged> {
    return {
      type: GlobalActions.ZAHLUNGSOPTIONEN_CHANGED,
      payload: zahlungsoptionenChanged,
    };
  }

  zahlungsoptionenChangedVorvertrag(
    zahlungsoptionenChanged: ZahlungsoptionenChanged,
  ): GlobalAction<ZahlungsoptionenChanged> {
    return {
      type: GlobalActions.ZAHLUNGSOPTIONEN_CHANGED_VORVERTRAG,
      payload: zahlungsoptionenChanged,
    };
  }

  treuebonusMaxReceived(
    treuebonusMaxReceived: TreuebonusMaxReceived,
  ): GlobalAction<TreuebonusMaxReceived> {
    return {
      type: GlobalActions.TREUEBONUS_MAX_RECEIVED,
      payload: treuebonusMaxReceived,
    };
  }

  initializeShop(shopData: InitializeShopPayload): GlobalAction<InitializeShopPayload> {
    return { type: GlobalActions.SHOP_INIT, payload: shopData };
  }

  setAccessToken(accessToken: string): GlobalAction<string> {
    return { type: GlobalActions.SET_ACCESS_TOKEN, payload: accessToken };
  }

  navigationCompleted(payload: NavigationRoute): GlobalAction<NavigationRoute> {
    return { type: GlobalActions.NAVIGATION_COMPLETED, payload };
  }

  doRequest<T>(payload: DoRequest<T>): GlobalAction<DoRequest<T>> {
    return {
      type: GlobalActions.DO_REQUEST,
      payload,
    };
  }

  doRequestAntragsnummer(
    appId: App,
    successEvent: string,
    errorEvent: string,
    angebotsId?: string,
    additionalData?: unknown,
  ): GlobalAction<DoRequest> {
    const payload: DoRequest = {
      body: '',
      appId,
      method: HTTP_METHOD.GET,
      responseType: ResponseType.PLAIN_TEXT,
      transformResponse: this.withoutTransformation,
      url: '/privatschutz/api/antragsnummer/generate',
      successEvent,
      errorEvent,
    };
    if (angebotsId) {
      payload.angebotsId = angebotsId;
    }
    if (additionalData) {
      payload.additionalData = additionalData;
    }
    return this.doRequest(payload);
  }

  quoteDBDataRequested(quoteDbRequest: QuoteDbRequestPayload): GlobalAction<QuoteDbRequestPayload> {
    return {
      type: GlobalActions.QUOTEDB_DATA_REQUESTED,
      payload: quoteDbRequest,
    };
  }

  quoteDBDashboardDataRequested(): GlobalAction<void> {
    return {
      type: GlobalActions.QUOTEDB_DASHBOARD_DATA_REQUESTED,
    };
  }

  quoteDBToolbarDataRequested(): GlobalAction<void> {
    return {
      type: GlobalActions.QUOTEDB_TOOLBAR_DATA_REQUESTED,
    };
  }

  quoteDBCheckoutDataRequested(): GlobalAction<void> {
    return {
      type: GlobalActions.QUOTEDB_CHECKOUT_DATA_REQUESTED,
    };
  }

  quoteDBInit(quoteDBInit: QuoteDbInitPayload): GlobalAction<QuoteDbInitPayload> {
    return {
      type: GlobalActions.QUOTEDB_INIT,
      payload: quoteDBInit,
    };
  }

  quoteDBDataDashboardGenerated(
    quoteDbDataDashboard: QuoteDbDashboardPayload,
  ): GlobalAction<QuoteDbDashboardPayload> {
    return {
      type: GlobalActions.QUOTEDB_DATA_DASHBOARD_GENERATED,
      payload: quoteDbDataDashboard,
    };
  }

  quoteDBDataSparteGenerated(
    quoteDbData: QuoteDbSpartePayload<unknown>,
  ): GlobalAction<QuoteDbSpartePayload<unknown>> {
    return {
      type: GlobalActions.QUOTEDB_DATA_SPARTE_GENERATED,
      payload: quoteDbData,
    };
  }

  quoteDBDataToolbarGenerated(
    quoteDbDataToolbar: QuoteDbToolbarPayload,
  ): GlobalAction<QuoteDbToolbarPayload> {
    return {
      type: GlobalActions.QUOTEDB_DATA_TOOLBAR_GENERATED,
      payload: quoteDbDataToolbar,
    };
  }

  quoteDBDataCheckoutGenerated(
    quoteDbDataCheckout: QuoteDbCheckoutPayload,
  ): GlobalAction<QuoteDbCheckoutPayload> {
    return {
      type: GlobalActions.QUOTEDB_DATA_CHECKOUT_GENERATED,
      payload: quoteDbDataCheckout,
    };
  }

  doRequestSuccessful<T>(
    responseData: T,
    doRequestAction: GlobalAction<DoRequest>,
  ): DoRequestResponse<T> {
    return {
      type: doRequestAction.payload.successEvent,
      payload: responseData,
      doRequestAction,
    };
  }

  doRequestFailed(
    responseData: AxiosError,
    doRequestAction: GlobalAction<DoRequest>,
  ): DoRequestResponse<AxiosError> {
    return {
      type: doRequestAction.payload.errorEvent,
      payload: responseData,
      doRequestAction,
    };
  }

  constructionPageRequested(): GlobalAction<void> {
    return {
      type: GlobalActions.CONSTRUCTION_PAGE_REQUESTED,
    };
  }

  requestModal(
    textKey: ModalType,
    text?: ModalRequested['content'],
    style?: ModalRequested['style'],
    options?: ModalRequested['options'],
  ): GlobalAction<ModalRequested> {
    return {
      type: GlobalActions.MODAL_REQUESTED,
      payload: { type: textKey, content: text, style, options },
    };
  }

  openMapViewModal(
    appId?: App,
    angebotsId?: string,
    adresseTarifierbar?: boolean,
    origin?: 'eingabe' | 'angebot',
  ): GlobalAction<{
    appId: App;
    angebotsId: string;
    adresseTarifierbar: boolean;
    origin: 'eingabe' | 'angebot';
  }> {
    return {
      type: GlobalActions.OPEN_MAP_VIEW_MODAL,
      payload: { appId, angebotsId, adresseTarifierbar, origin },
    };
  }

  closeMapViewModal(): GlobalAction<void> {
    return {
      type: GlobalActions.CLOSE_MAP_VIEW_MODAL,
    };
  }

  showModal(content: ShowModal): GlobalAction<ShowModal> {
    return {
      type: GlobalActions.SHOW_MODAL,
      payload: content,
    };
  }

  closeModal(clickedButtonType: ModalCloseReason): AnyAction {
    return {
      type: GlobalActions.CLOSE_MODAL,
      payload: clickedButtonType,
    };
  }

  errorPageRequested(): GlobalAction<void> {
    return {
      type: GlobalActions.ERROR_PAGE_REQUESTED,
    };
  }

  errorPageWithCustomContentRequested(
    errorTextId: string | string[],
    zusatzInfo?: string[],
    params?: { [key: string]: string },
  ): GlobalAction<ErrorPageContent> {
    return {
      type: GlobalActions.ERROR_PAGE_REQUESTED,
      payload: { errorTextId, zusatzInfo, params },
    };
  }

  speichernRequested(forwardToUnderwriter?: boolean): AnyAction {
    return {
      type: GlobalActions.SPEICHERN_REQUESTED,
      payload: { forwardToUnderwriter },
    };
  }

  speicherdatenRequested(): AnyAction {
    return { type: GlobalActions.SPEICHERDATEN_REQUESTED };
  }

  speicherdatenRequestedCap(): AnyAction {
    return { type: GlobalActions.SPEICHERDATEN_REQUESTED_CAP };
  }

  kdvMetadatenRequested(): AnyAction {
    return { type: GlobalActions.KDV_METADATEN_REQUESTED };
  }

  kdvMetadatenInit(kdvmetadaten: KdvMetadaten): GlobalAction<KdvMetadaten> {
    return { type: GlobalActions.KDV_METADATEN_INIT, payload: kdvmetadaten };
  }

  saveStatusReceived(payload: SpeichernStatus): GlobalAction<SpeichernStatus> {
    return { type: GlobalActions.SAVE_STATUS_RECEIVED, payload };
  }

  offerSavedWithCryptId(
    payload: OfferSavedWithCryptIdPayload,
  ): GlobalAction<OfferSavedWithCryptIdPayload> {
    return { type: GlobalActions.OFFER_SAVED_WITH_CRYPTID, payload };
  }

  updateDocumentsWithCryptId(payload: {
    documentIds: string[];
    cryptId: string;
    appId?: App;
    isSdwSession?: boolean;
  }): GlobalAction<{
    documentIds: string[];
    cryptId: string;
    appId?: App;
    isSdwSession?: boolean;
  }> {
    return { type: GlobalActions.UPDATE_DOCUMENTS_WITH_CRYPTID, payload };
  }

  savedDokumentIdReceived(payload: string): GlobalAction<string> {
    return { type: GlobalActions.SAVED_DOKUMENTID_RECEIVED, payload };
  }

  immobilieUebernehmen(
    immobilie: Immobilie,
    appId: App,
    angebotsId?: string,
    isAuslandsImmobilie?: boolean,
  ): GlobalAction<ImmobilieUebernehmenPayload> {
    return {
      type: GlobalActions.IMMOBILIE_UEBERNEHMEN,
      payload: { appId, angebotsId, immobilie, isAuslandsImmobilie },
    };
  }

  vorschlagsdatenGenerated(vorschlagsdaten: SparteAntrag): GlobalAction<SparteAntrag> {
    return {
      type: GlobalActions.VORSCHLAGDATEN_GENERATED,
      payload: vorschlagsdaten,
    };
  }

  vorschlagsdatenRequested(angebotsIds: AngebotsId[]): GlobalAction<VorschlagsdatenRequestPayload> {
    return {
      type: GlobalActions.VORSCHLAGDATEN_REQUESTED,
      payload: { angebotsIds },
    };
  }

  navigationRequested(payload: NavigationRoute): GlobalAction<NavigationRoute> {
    return { type: GlobalActions.NAVIGATION_REQUESTED, payload };
  }

  elementarFragebogenProvided(
    payload: UnderwriterFragebogenCheckout,
  ): GlobalAction<UnderwriterFragebogenCheckout> {
    return { type: GlobalActions.ELEMENTARFRAGEBOGEN_PROVIDED, payload };
  }

  navigateToCheckoutRequested(): GlobalAction<void> {
    return { type: GlobalActions.NAVIGATE_TO_CHECKOUT_REQUESTED };
  }

  locationChanged(payload: NavigationRoute): GlobalAction<NavigationRoute> {
    return { type: GlobalActions.LOCATION_CHANGED, payload };
  }

  einstiegSuccessful(einstiegResponse: EinstiegResponse): GlobalAction<EinstiegResponse> {
    return {
      type: GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL,
      payload: einstiegResponse,
    };
  }

  einstiegWithInvalidAddress(): GlobalAction<void> {
    return {
      type: GlobalActions.EINSTIEG_WITH_INVALID_ADDRESS,
    };
  }

  amisImmobilienTransformed(
    transformedImmobilien: Array<Immobilie>,
  ): GlobalAction<Array<Immobilie>> {
    return {
      type: GlobalActions.AMIS_IMMOBILIEN_TRANSFORMED,
      payload: transformedImmobilien,
    };
  }

  einstiegFailed(reason: string): GlobalAction<string> {
    return { type: GlobalActions.EINSTIEG_REQUEST_FAILED, payload: reason };
  }

  amisCrmImmobilieRequested(): GlobalAction<void> {
    return { type: GlobalActions.AMIS_CRM_IMMOBILIE_REQUESTED };
  }

  amisCrmImmobilieRequestFailed(): GlobalAction<void> {
    return { type: GlobalActions.AMIS_CRM_IMMOBILIE_REQUEST_FAILED };
  }

  amisCrmPersonenGruppeRequested(
    kundenverwaltungID: string,
    groupId: string,
  ): GlobalAction<{ kundenverwaltungID: string; groupId: string }> {
    return {
      type: GlobalActions.AMIS_CRM_PERSONENGRUPPE_REQUESTED,
      payload: { kundenverwaltungID, groupId },
    };
  }

  addProduktToAngebote(
    appId: App,
    angebotsdatum: string,
    angebotsId?: string,
    ownerAppId?: App,
  ): AddProduktToAngebotAction {
    const action: AddProduktToAngebotAction = {
      type: GlobalActions.ADD_PRODUKT_TO_ANGEBOTE,
      payload: { appId, angebotsdatum },
    };

    if (isMultistoreApp(appId)) {
      action.payload.angebotsId = angebotsId || uuidv1();
    }

    if (ownerAppId) {
      action.payload.ownerAppId = ownerAppId;
    }

    return action;
  }

  addVertragToAngebote(
    addVertragToAngebote: AddVertragToAngebote,
  ): GlobalAction<AddVertragToAngebote> {
    const action = {
      type: GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE,
      payload: addVertragToAngebote,
    };

    if (isMultistoreApp(addVertragToAngebote.appId) && !addVertragToAngebote.angebotsId) {
      action.payload.angebotsId = uuidv1();
    }

    return action;
  }

  vorbelegungRequested(vorbelegungPayload: VorbelegungPayload): GlobalAction<VorbelegungPayload> {
    return {
      type: GlobalActions.VORBELEGUNG_REQUESTED,
      payload: vorbelegungPayload,
    };
  }

  vorbelegungForBeibehaltungRequested(
    vorbelegungdaten: Vorbelegungdaten,
  ): GlobalAction<Vorbelegungdaten> {
    return {
      type: GlobalActions.VORBELEGUNG_FOR_BEIBEHALTUNG_REQUESTED,
      payload: vorbelegungdaten,
    };
  }

  vorbelegungFinished(vorbelegungPayload: VorbelegungPayload): GlobalAction<VorbelegungPayload> {
    return {
      type: GlobalActions.VORBELEGUNG_FINISHED,
      payload: vorbelegungPayload,
    };
  }

  thhHundVorbelegungFinished(
    vorbelegungPayload: VorbelegungPayload,
  ): GlobalAction<VorbelegungPayload> {
    return {
      type: GlobalActions.THH_HUND_VORBELEGUNG_FINISHED,
      payload: vorbelegungPayload,
    };
  }

  thhPferdVorbelegungFinished(
    vorbelegungPayload: VorbelegungPayload,
  ): GlobalAction<VorbelegungPayload> {
    return {
      type: GlobalActions.THH_PFERD_VORBELEGUNG_FINISHED,
      payload: vorbelegungPayload,
    };
  }

  requestAddVertragToAngebote(
    addVertragToAngebote: AddVertragToAngebote,
  ): GlobalAction<AddVertragToAngebote> {
    return {
      type: GlobalActions.ADD_VORVERTRAG_TO_ANGEBOTE_REQUESTED,
      payload: addVertragToAngebote,
    };
  }

  savedStatesLoaded(
    savedStatesLoaded: SavedStateWrapper[],
    savedSensitiveStatesLoaded?: SavedState,
  ): GlobalAction<WrappedSavedStatesLoaded> {
    return {
      type: GlobalActions.SAVED_STATES_LOADED,
      payload: {
        savedStatesLoaded,
        savedSensitiveStatesLoaded,
      },
    };
  }

  updateLoadedStates(): GlobalAction<undefined> {
    return {
      type: GlobalActions.UPDATE_LOADED_STATES,
    };
  }

  // wird nur lokal geschmissen
  deltafaktorenChanged(deltafaktoren: DeltafaktorenChanged): GlobalAction<DeltafaktorenChanged> {
    return {
      type: GlobalActions.DELTAFAKTOREN_RECEIVED,
      payload: deltafaktoren,
    };
  }

  tarifgenerationDataReceived(
    tarifgenerationData: TarifgenerationData,
  ): GlobalAction<TarifgenerationData> {
    return {
      type: GlobalActions.TARIFGENERATION_DATA_RECEIVED,
      payload: tarifgenerationData,
    };
  }

  deltafaktorOutOfRange(appId: App, angebotsId?: string): GlobalAction<AngebotsId> {
    return {
      type: GlobalActions.OUT_OF_DELTA_RANGE,
      payload: { appId, angebotsId },
    };
  }

  rbdMaxReceived(rbdMaxReceived: RbdMaxReceived): GlobalAction<RbdMaxReceived> {
    return { type: GlobalActions.RBD_MAX_RECEIVED, payload: rbdMaxReceived };
  }

  nachlassReceived(nachlassReceived: NachlassReceived): GlobalAction<NachlassReceived> {
    return { type: GlobalActions.NACHLASS_RECEIVED, payload: nachlassReceived };
  }

  // wird nur lokal geschmissen
  preisverzeichnisChanged(
    preisverzeichnisChanged: PreisverzeichnisChanged,
  ): GlobalAction<PreisverzeichnisChanged> {
    return {
      type: GlobalActions.PREISVERZEICHNIS_CHANGED,
      payload: preisverzeichnisChanged,
    };
  }

  vereinbarungenChanged(
    rbdArray: Array<RbdChanged>,
    tbArray: Array<TreuebonusChanged>,
    kuendigungenArray: Array<KuendigungenChanged> = [],
    vorteilsRabattArray: Array<VorteilsrabattPayload> = [],
  ): GlobalAction<VereinbarungenChanged> {
    return {
      type: GlobalActions.VEREINBARUNGEN_CHANGED,
      payload: {
        rbdChanges: rbdArray,
        tbChanges: tbArray,
        kuendingungChanged: kuendigungenArray,
        vorteilsRabattArray: vorteilsRabattArray,
      },
    };
  }

  newHashedTaasRequest(appId: App, hash: string): GlobalAction<{ appId: App; hash: string }> {
    return {
      type: GlobalActions.NEW_HASHED_TAAS_REQUEST,
      payload: { appId, hash },
    };
  }

  inDashboardUebernehmen(dataForDashboard: DataForDashboard): GlobalAction<DataForDashboard> {
    return {
      type: GlobalActions.IN_DASHBOARD_UEBERNEHMEN,
      payload: dataForDashboard,
    };
  }

  updateDashboardAfterLoadAzam(
    dataForDashboardAfterLoad: DataForDashboardAfterLoadAzam,
  ): GlobalAction<DataForDashboardAfterLoadAzam> {
    return {
      type: GlobalActions.UPDATE_DASHBOARD_AFTER_LOAD_AZAM,
      payload: dataForDashboardAfterLoad,
    };
  }

  updateCheckoutAfterLoadAzam(
    dataForCheckoutAfterLoad: CheckoutProduktAfterLoadAzam,
  ): GlobalAction<CheckoutProduktAfterLoadAzam> {
    return {
      type: GlobalActions.UPDATE_CHECKOUT_AFTER_LOAD_AZAM,
      payload: dataForCheckoutAfterLoad,
    };
  }

  preiseInsDashboardUebernehmen(
    preiseForDashboard: PreiseForDashboard,
  ): GlobalAction<PreiseForDashboard> {
    return {
      type: GlobalActions.PREISE_INS_DASHBOARD_UEBERNEHMEN,
      payload: preiseForDashboard,
    };
  }

  preiseResetDashboard(preiseForDashboard: PreiseForDashboard): GlobalAction<PreiseForDashboard> {
    return {
      type: GlobalActions.PREISE_RESET_DASHBOARD,
      payload: preiseForDashboard,
    };
  }

  // wird nur lokal geschmissen
  gisDatenErmittelt(gisDaten: StreckenGisDaten): GlobalAction<GisDatenErmitteltPayload> {
    return { type: GlobalActions.GISDATEN_ERMITTELT, payload: { gisDaten } };
  }

  vorvertragVorschaedenErmittelt(
    vorschaeden: Array<VorvertragVorschaeden>,
  ): GlobalAction<Array<VorvertragVorschaeden>> {
    return {
      type: GlobalActions.VORVERTRAG_VORSCHAEDEN_ERMITTELT,
      payload: vorschaeden,
    };
  }

  produktAction(produkt: CheckoutProdukt): GlobalAction<CheckoutProdukt> {
    return {
      type: GlobalActions.PRODUKT_ACTION,
      payload: produkt,
    };
  }

  /**
   * `skipSammelantragsnummer` is set for the offers of a Tiergruppe that are not the last one
   * to be taken over: the checkout generates its Sammelantragsnummer once for the group.
   */
  antragsnummerGenerated(skipSammelantragsnummer = false): GlobalAction<unknown> {
    return skipSammelantragsnummer
      ? { type: GlobalActions.ANTRAGSNUMMER_GENERATED, payload: { skipSammelantragsnummer } }
      : { type: GlobalActions.ANTRAGSNUMMER_GENERATED };
  }

  roleDetermined(role: Role): GlobalAction<RoleDeterminedPayload> {
    return { type: GlobalActions.ROLE_DETERMINED, payload: { role } };
  }

  createStateSnapshot(appId: App, angebotsId?: string): GlobalAction<AngebotsId> {
    return {
      type: GlobalActions.CREATE_STATE_SNAPSHOT,
      payload: { appId, angebotsId },
    };
  }

  stateSnapshotCreated(appId: App, angebotsId?: string): GlobalAction<AngebotsId> {
    return {
      type: GlobalActions.STATE_SNAPSHOT_CREATED,
      payload: { appId, angebotsId },
    };
  }

  restoreStateSnapshot(appId?: App, angebotsId?: string): GlobalAction<AngebotsId> {
    return {
      type: GlobalActions.RESTORE_STATE_SNAPSHOT,
      payload: { appId, angebotsId },
    };
  }

  restoreStateSnapshotFinished(appId?: App): GlobalAction<App> {
    return {
      type: GlobalActions.RESTORE_STATE_SNAPSHOT_FINISHED,
      payload: appId,
    };
  }

  createStateSnapshotForAllApps(
    triggeredByAction: GlobalAction<unknown>,
  ): GlobalAction<GlobalAction<unknown>> {
    return {
      type: GlobalActions.CREATE_STATE_SNAPSHOT_FOR_ALL_APPS,
      payload: triggeredByAction,
    };
  }

  stateSnapshotForAllAppsCreated(
    triggeredByAction: GlobalAction<unknown>,
  ): GlobalAction<GlobalAction<unknown>> {
    return {
      type: GlobalActions.STATE_SNAPSHOT_FOR_ALL_APPS_CREATED,
      payload: triggeredByAction,
    };
  }

  replaceState<T>(appState: T, appId: App, angebotsId?: string): GlobalAction<ReplaceState<T>> {
    return {
      type: GlobalActions.REPLACE_STATE,
      payload: { appState, appId, angebotsId },
    };
  }

  produktRequested(payload: ProduktRequested): GlobalAction<ProduktRequested> {
    return { type: GlobalActions.PRODUKT_REQUESTED, payload };
  }

  produktRequestedAfterSave(payload: ProduktRequested): GlobalAction<ProduktRequested> {
    return { type: GlobalActions.PRODUKT_REQUESTED_AFTER_SAVE, payload };
  }

  produktReceived(payload: MasterProduktData): GlobalAction<MasterProduktData> {
    return { type: GlobalActions.PRODUKT_RECEIVED, payload };
  }

  produktReceivedAfterSave(payload: MasterProduktData): GlobalAction<MasterProduktData> {
    return { type: GlobalActions.PRODUKT_RECEIVED_AFTER_SAVE, payload };
  }

  druckdatenGenerated(druckdaten: SparteDruckdaten): GlobalAction<SparteDruckdaten> {
    return { type: GlobalActions.DRUCKDATEN_GENERATED, payload: druckdaten };
  }

  druckdatenRequested(appIds: string[]): GlobalAction<DruckRequestPayload> {
    return {
      type: GlobalActions.DRUCKDATEN_REQUESTED,
      payload: { appIds },
    };
  }

  openForwardedToUnderwriterPage(): GlobalAction<void> {
    return {
      type: GlobalActions.OPEN_FORWARDED_TO_UNDERWRITER_PAGE,
    };
  }

  closeForwardedToUnderwriterPage(): GlobalAction<void> {
    return {
      type: GlobalActions.CLOSE_FORWARDED_TO_UNDERWRITER_PAGE,
    };
  }

  produktDeleted(
    angebotsIds: Array<AngebotsId>,
    vorvertragsnummern: Array<FEVorvertragsnummer> = [],
  ): GlobalAction<ProduktDeleted> {
    return {
      type: GlobalActions.PRODUKT_DELETED,
      payload: { angebotsIds, vorvertragsnummern },
    };
  }

  zaehlstueckeReceived(zaehlstuecke: ZaehlstueckeReceived): GlobalAction<ZaehlstueckeReceived> {
    return { type: GlobalActions.ZAEHLSTUECKE_RECEIVED, payload: zaehlstuecke };
  }

  vermerkInit(vermerkInfo: VermerkInfo[]): GlobalAction<VermerkInfo[]> {
    return { type: GlobalActions.VERMERK_INIT, payload: vermerkInfo };
  }

  toggleSpeichernModalChanged(toggle: boolean): GlobalAction<boolean> {
    return { type: GlobalActions.TOGGLE_MODAL, payload: toggle };
  }

  speicherdatenGenerated(speicherDaten: AvUpdateRequestModel): GlobalAction<AvUpdateRequestModel> {
    return {
      type: GlobalActions.SPEICHERDATEN_GENERATED,
      payload: speicherDaten,
    };
  }

  speicherdatenGeneratedForCap(
    speicherDaten: UpdateAvRequestModelForCap,
  ): GlobalAction<UpdateAvRequestModelForCap> {
    return {
      type: GlobalActions.SPEICHERDATEN_GENERATED_CAP,
      payload: speicherDaten,
    };
  }

  sofortschutzAvailable(
    sofortschutzAvailable: SofortschutzAvailableItem[],
  ): GlobalAction<SofortschutzAvailableItem[]> {
    return {
      type: GlobalActions.SOFORTSCHUTZ_AVAILABLE,
      payload: sofortschutzAvailable,
    };
  }

  updateZaehlstuecke(): GlobalAction<null> {
    return { type: GlobalActions.UPDATE_ZAEHLSTUECKE };
  }

  tarifiereShop(originAction: GlobalAction<unknown>): GlobalAction<GlobalAction<unknown>> {
    return { type: GlobalActions.TARIFIERE_SHOP, payload: originAction };
  }

  tarifiereShopSync(originAction: GlobalAction<unknown>): GlobalAction<GlobalAction<unknown>> {
    return { type: GlobalActions.TARIFIERE_SHOP_SYNC, payload: originAction };
  }

  tarifiereAngebotForShop(appId: App, angebotsId?: string): TarifiereAngebotForShopAction {
    return {
      type: GlobalActions.TARIFIERE_ANGEBOT_FOR_SHOP,
      payload: { appId, angebotsId },
    };
  }

  updateSofortschutzActiveFinished(): GlobalAction<null> {
    return { type: GlobalActions.UPDATE_SOFORTSCHUTZ_ACTIVE_FINISHED };
  }

  versicherungsbeginnChanged(
    versicherungsBeginnGeaendert: BeginnAblaufGeaendert,
  ): GlobalAction<BeginnAblaufGeaendert> {
    return {
      type: GlobalActions.VERSICHERUNGSBEGINN_CHANGED,
      payload: versicherungsBeginnGeaendert,
    };
  }

  resetBeginnAblauf(appId: App, angebotsId?: string): GlobalAction<AngebotsId> {
    return {
      type: GlobalActions.RESET_BEGINN_ABLAUF,
      payload: { appId, angebotsId },
    };
  }

  updateSofortschutzAvailable(): GlobalAction<null> {
    return { type: GlobalActions.UPDATE_SOFORTSCHUTZ_AVAILABLE };
  }

  tarifiereShopSuccess(): GlobalAction<void> {
    return { type: GlobalActions.TARIFIERE_SHOP_SUCCESS };
  }

  tarifiereShopFailed(): GlobalAction<void> {
    return { type: GlobalActions.TARIFIERE_SHOP_FAILED };
  }

  tarifiereShopStale(): GlobalAction<void> {
    return { type: GlobalActions.TARIFIERE_SHOP_STALE };
  }

  createStreckeSnapshot(payload: AngebotsId): GlobalAction<AngebotsId> {
    return { type: GlobalActions.CREATE_STRECKEN_SNAPSHOT, payload };
  }

  restoreStreckeSnapshot(appId: App, angebotId?: string): GlobalAction<AngebotsId> {
    return {
      type: GlobalActions.RESTORE_STRECKEN_SNAPSHOT,
      payload: { appId, angebotsId: angebotId },
    };
  }

  updateSofortschutzActive(appId: App, angebotsId?: string): GlobalAction<AngebotsId> {
    return {
      type: GlobalActions.UPDATE_SOFORTSCHUTZ_ACTIVE,
      payload: { appId, angebotsId },
    };
  }

  provideAngeboteInWarenkorb(
    angeboteInWarenkorb: Array<AngebotsId>,
  ): GlobalAction<Array<AngebotsId>> {
    return {
      type: GlobalActions.ANGEBOTE_IN_WARENKORB_PROVIDED,
      payload: angeboteInWarenkorb,
    };
  }

  provideIsBeibehaltenesAngebotInWarenkorb(
    isBeibehaltenesAngebotVorhanden: boolean,
  ): GlobalAction<boolean> {
    return {
      type: GlobalActions.BEIBEHALTENE_ANGEBOTE_IN_WARENKORB_PROVIDED,
      payload: isBeibehaltenesAngebotVorhanden,
    };
  }

  requestAngeboteInWarenkorb(): AnyAction {
    return { type: GlobalActions.ANGEBOTE_IN_WARENKORB_REQUESTED };
  }

  provideMultiangebotAdressValidation(
    payload: ProvideVorhandeneVwgValidationPayload,
  ): GlobalAction<ProvideVorhandeneVwgValidationPayload> {
    return {
      type: GlobalActions.PROVIDE_MULTIANGEBOT_ADRESS_VALIDATION,
      payload,
    };
  }

  requestMultiangebotAdressValidation(
    payload: RequestVorhandeneValidationPayload,
  ): GlobalAction<RequestVorhandeneValidationPayload> {
    return {
      type: GlobalActions.REQUEST_MULTIANGEBOT_VWG_ADRESS_VALIDATION,
      payload,
    };
  }

  provideVorvertragStatusValidation(
    payload: ProvideVorvertragStatusValidationPayload,
  ): GlobalAction<ProvideVorvertragStatusValidationPayload> {
    return {
      type: GlobalActions.PROVIDE_VORVERTRAG_STATUS_VALIDATION,
      payload,
    };
  }

  requestVorvertragStatusValidation(
    payload: RequestVorvertragStatusValidationPayload,
  ): GlobalAction<RequestVorvertragStatusValidationPayload> {
    return {
      type: GlobalActions.REQUEST_VORVERTRAG_STATUS_VALIDATION,
      payload,
    };
  }

  requestStructuredRisikoort(appId: App): GlobalAction<App> {
    return {
      type: GlobalActions.STRUCTURED_RISIKOORT_REQUESTED,
      payload: appId,
    };
  }

  provideStructuredRisikoort(
    appId: App,
    angebotsId: string,
    risikoort: BasisAdresse,
  ): GlobalAction<StructuredRisikoortPayload> {
    return {
      type: GlobalActions.STRUCTURED_RISIKOORT_PROVIDED,
      payload: { appId, angebotsId, risikoort },
    };
  }

  vorversicherungAblaufdatumChanged(
    vorversicherungAblaufdatumChanged: VorversicherungAblaufdatumChanged,
  ): GlobalAction<VorversicherungAblaufdatumChanged> {
    return {
      type: GlobalActions.VORVERSICHERUNG_ABLAUFDATUM_CHANGED,
      payload: vorversicherungAblaufdatumChanged,
    };
  }

  logError(appId: App, errorOrExceptionText: string, message = ''): GlobalAction<LogError> {
    return {
      type: GlobalActions.LOG_ERROR,
      payload: { appId, errorOrExceptionText, message },
    };
  }

  unfallZaehlstueckeChanged(value: number): GlobalAction<number> {
    return { type: GlobalActions.UNFALL_ZAEHLSTUECKE_CHANGED, payload: value };
  }

  preiseStreckeErmittelt(
    appId: App,
    tarifierteProduktlinien: Array<Produktlinie>,
    taasResponsePayload: TaasResponseModel,
    angebotsId?: string,
  ): GlobalAction<PreiseStreckeErmittelt> {
    return {
      type: GlobalActions.PREISE_STRECKE_ERMITTELT,
      payload: {
        appId,
        tarifierteProduktlinien,
        taasResponsePayload,
        angebotsId,
      },
    };
  }

  loadVorvertraege(
    kundennummer: string,
    vermittlernummer: Vermittlernummer,
    perId: string,
    newVorgang: boolean,
    fremdStandard?: Array<BasicVertragsdaten>,
    fremdStandalone?: Array<BasicVertragsdaten>,
  ): GlobalAction<LoadVorvertraege> {
    return {
      type: GlobalActions.LOAD_VORVERTRAEGE,
      payload: {
        kundennummer,
        vermittlernummer,
        perId,
        loadBankverbindungen: newVorgang,
        fremdStandard,
        fremdStandalone,
      },
    };
  }

  updateVorvertraegeFailed(): GlobalAction<void> {
    return { type: GlobalActions.UPDATE_VORVERTRAEGE_FAILED };
  }

  vorvertraegeLoadFinished(): GlobalAction<void> {
    return { type: GlobalActions.VORVERTRAEGE_LOAD_FINISHED };
  }

  updateVorvertraege(
    standardVorvertraege: Array<Vorvertrag>,
    standaloneVorvertraege: Array<StandaloneProdukt>,
    bankverbindungen: Array<BankverbindungVorvertrag>,
    maxAnzahlVorvertraegeErreicht: boolean,
  ): GlobalAction<UpdateLoadedVorvertraege> {
    return {
      type: GlobalActions.UPDATE_VORVERTRAEGE,
      payload: {
        standardVorvertraege,
        standaloneVorvertraege,
        bankverbindungen,
        maxAnzahlVorvertraegeErreicht,
      },
    };
  }

  updateSofortschutzEndDate(standardVorvertraege: Array<Vorvertrag>): GlobalAction<Vorvertrag[]> {
    return {
      type: GlobalActions.UPDATE_SOFORTSCHUTZ_END_DATE,
      payload: standardVorvertraege,
    };
  }

  // wird nur lokal geschmissen
  changeRelevantRiskdataHash(hash: string): GlobalAction<{ hash: string }> {
    return {
      type: GlobalActions.CHANGE_RELEVANT_RISKDATA_HASH,
      payload: { hash },
    };
  }

  triggerTarifierung(): GlobalAction<void> {
    return { type: GlobalActions.TARIFIERUNG_TRIGGERED };
  }

  triggerTarifierungBeibehaltung(payload: AngebotsId): GlobalAction<AngebotsId> {
    return { type: GlobalActions.TARIFIERUNG_TRIGGERED_BEIBEHALTUNG, payload };
  }

  assekuranztarifChanged(value: boolean): GlobalAction<boolean> {
    return {
      type: GlobalActions.ASSEKURANZTARIF_CHANGED,
      payload: value,
    };
  }

  assekuranztarifChangedVorvertrag(value: boolean): GlobalAction<boolean> {
    return {
      type: GlobalActions.ASSEKURANZTARIF_CHANGED_VORVERTRAG,
      payload: value,
    };
  }

  assekuranztarifMixed(value: boolean): GlobalAction<boolean> {
    return {
      type: GlobalActions.ASSEKURANZTARIF_MIXED,
      payload: value,
    };
  }

  assekuranztarifVorbelegt(): GlobalAction<void> {
    return {
      type: GlobalActions.ASSEKURANZTARIF_VORBELEGT,
    };
  }

  updateAssekuranztarifData(value: boolean): GlobalAction<boolean> {
    return {
      type: GlobalActions.UPDATE_ASSEKURANZTARIF_DATA,
      payload: value,
    };
  }

  updateAssekuranztarifDataAfterVorvertraegeLoad(value: boolean): GlobalAction<boolean> {
    return {
      type: GlobalActions.UPDATE_ASSEKURANZTARIF_DATA_AFTER_VV_LOAD,
      payload: value,
    };
  }

  rabattHinweisChanged(value: boolean): GlobalAction<boolean> {
    return { type: GlobalActions.RABATT_HINWEIS_CHANGED, payload: value };
  }

  vorteilsRabattHinweisChanged(value: boolean): GlobalAction<boolean> {
    return { type: GlobalActions.VORTEILS_RABATT_HINWEIS_CHANGED, payload: value };
  }

  hunderassenListeRetrieved(
    hunderassenListe: Array<IAnimalValueLabelElement>,
  ): GlobalAction<Array<IAnimalValueLabelElement>> {
    return {
      type: GlobalActions.HUNDERASSENLISTE_RETRIEVED,
      payload: hunderassenListe,
    };
  }

  thhHunderassenListeRetrieved(
    hunderassenListe: Array<IAnimalValueLabelElement>,
  ): GlobalAction<Array<IAnimalValueLabelElement>> {
    return {
      type: GlobalActions.THH_HUNDERASSEN_LISTE_RETRIEVED,
      payload: hunderassenListe,
    };
  }

  pferderassenListeRetrieved(
    pferderassenListe: Array<ValueLabelElement>,
  ): GlobalAction<Array<ValueLabelElement>> {
    return {
      type: GlobalActions.PFERDERASSEN_LISTE_RETRIEVED,
      payload: pferderassenListe,
    };
  }

  thhPferderassenListeRetrieved(
    pferderassenListe: Array<ValueLabelElement>,
  ): GlobalAction<Array<ValueLabelElement>> {
    return {
      type: GlobalActions.THH_PFERDERASSEN_LISTE_RETRIEVED,
      payload: pferderassenListe,
    };
  }

  katzenrassenListeRetrieved(
    katzenrassenListe: Array<ValueLabelElement>,
  ): GlobalAction<Array<ValueLabelElement>> {
    return {
      type: GlobalActions.KATZENRASSEN_LISTE_RETRIEVED,
      payload: katzenrassenListe,
    };
  }

  animalIllnessesRecieved(animalIllnesses: AnimalIllnesses): GlobalAction<AnimalIllnesses> {
    return {
      type: GlobalActions.ANIMAL_ILLNESSES_RECEIVED,
      payload: animalIllnesses,
    };
  }

  loggerInitialized(): GlobalAction<void> {
    return { type: GlobalActions.LOGGER_INITIALIZED };
  }

  globalModalStatusRequested(): GlobalAction<void> {
    return { type: GlobalActions.SHOP_MODAL_STATUS_REQUESTED };
  }

  globalModalStatusRecieved(modalOpen: boolean): GlobalAction<boolean> {
    return {
      type: GlobalActions.SHOP_MODAL_STATUS_RECIEVED,
      payload: modalOpen,
    };
  }

  requestInitialStoreManagementData(): AnyAction {
    return { type: GlobalActions.INITIAL_STORE_MANAGEMENT_DATA_REQUESTED };
  }

  provideInitialStoreManagementData(
    payload: ProvideStoreCreationDataPayload,
  ): ProvideStoreCreationDataAction {
    return { type: GlobalActions.INITIAL_STORE_MANAGEMENT_DATA_PROVIDED, payload };
  }

  requestVnWechselData(payload: FEVorvertragsnummer[]): GlobalAction<FEVorvertragsnummer[]> {
    return { type: GlobalActions.VN_WECHSEL_DATA_REQUESTED, payload };
  }

  provideVnWechselData(vnWechselAngaben: VnWechselAngaben): GlobalAction<VnWechselAngaben> {
    return {
      type: GlobalActions.VN_WECHSEL_DATA_PROVIDED,
      payload: vnWechselAngaben,
    };
  }

  allMissingStoresCreated(): GlobalAction<void> {
    return { type: GlobalActions.ALL_MISSING_STORES_CREATED };
  }

  tiergruppeAngebotEditRequested(angebotsId: AngebotsId): GlobalAction<AngebotsId> {
    return { type: GlobalActions.TIERGRUPPE_ANGEBOT_EDIT_REQUESTED, payload: angebotsId };
  }

  tiergruppeEingabeTargetSet(target: TgvEingabeTarget): GlobalAction<TgvEingabeTarget> {
    return { type: GlobalActions.TIERGRUPPE_EINGABE_TARGET_SET, payload: target };
  }

  tiergruppeUebernommen(): GlobalAction<void> {
    return { type: GlobalActions.TIERGRUPPE_UEBERNOMMEN };
  }

  tiergruppeTakeOverStarted(): GlobalAction<void> {
    return { type: GlobalActions.TIERGRUPPE_TAKE_OVER_STARTED };
  }

  tiergruppeTakeOverEnded(): GlobalAction<void> {
    return { type: GlobalActions.TIERGRUPPE_TAKE_OVER_ENDED };
  }

  ownedStoreInitialized(angebotsId: AngebotsId): GlobalAction<AngebotsId> {
    return { type: GlobalActions.OWNED_STORE_INITIALIZED, payload: angebotsId };
  }

  setPriceGuarantee(priceGuarantee: boolean): GlobalAction<boolean> {
    return { type: GlobalActions.SET_PRICE_GUARANTEE, payload: priceGuarantee };
  }

  tarifbereichChanged(tarifbereich: Tarifbereich): GlobalAction<Tarifbereich> {
    return { type: GlobalActions.TARIFBEREICH_CHANGED, payload: tarifbereich };
  }

  requestVermittlernummer(): GlobalAction<undefined> {
    return {
      type: GlobalActions.REQUEST_VERMITTLERNUMMER,
    };
  }

  provideVermittlernummer(vermittlernummer: string): ProvideVermittlernummerAction {
    return {
      type: GlobalActions.PROVIDE_VERMITTLERNUMMER,
      payload: vermittlernummer,
    };
  }

  initialHauptfaelligkeitRequested(): GlobalAction<undefined> {
    return {
      type: GlobalActions.INITIAL_HAUPTFAELLIGKEIT_REQUESTED,
    };
  }

  userLoggedOut(): GlobalAction<undefined> {
    return {
      type: GlobalActions.USER_LOGGED_OUT,
    };
  }

  hauptfaelligkeitChanged(hauptfaelligkeitDatum: string): GlobalAction<string> {
    return {
      type: GlobalActions.HAUPTFAELLIGKEIT_CHANGED,
      payload: hauptfaelligkeitDatum,
    };
  }

  hauptfaelligkeitJHPChanged(hauptfaelligkeitDatum: string): GlobalAction<string> {
    return {
      type: GlobalActions.HAUPTFAELLIGKEIT_JHP_CHANGED,
      payload: hauptfaelligkeitDatum,
    };
  }

  mindestvertragslaufzeitCheckboxChanged(checked: boolean): GlobalAction<boolean> {
    return {
      type: GlobalActions.MINDESTVERTRAGSLAUFZEIT_CHECKBOX_CHANGED,
      payload: checked,
    };
  }

  vorvertragBeibehalten(vertrag: Vorvertrag): GlobalAction<Vorvertrag> {
    return {
      type: GlobalActions.VORVERTRAG_BEIBEHALTEN,
      payload: vertrag,
    };
  }

  beibehaltungProduktRequested(
    payload: BeibehaltungProduktRequestedPayload,
  ): GlobalAction<BeibehaltungProduktRequestedPayload> {
    return {
      type: GlobalActions.BEIBEHALTUNG_PRODUKT_REQUESTED,
      payload,
    };
  }

  vnWechselGrundChanged(fremdVNVorvertrag: FremdVNVorvertrag): GlobalAction<FremdVNVorvertrag> {
    return {
      type: GlobalActions.VN_WECHSEL_GRUND_CHANGED,
      payload: fremdVNVorvertrag,
    };
  }

  bffVersionUpdated(bffVersion: string): GlobalAction<string> {
    return {
      type: GlobalActions.BFF_VERSION_UPDATED,
      payload: bffVersion,
    };
  }

  unfallVpUebernehmen(
    vp: PersonensucheParty,
    isVn: boolean,
    angebotsId: AngebotsId['angebotsId'],
  ): GlobalAction<UnfallVPUbernehmenPayload> {
    return {
      type: GlobalActions.DASHBOARD_UNFALL_VP_UEBERNEHMEN,
      payload: { vp, isVn, angebotsId },
    };
  }

  openUnfallPersonensuche(): GlobalAction<PersonensucheModal> {
    return {
      type: GlobalActions.TOGGLE_PERSONENSUCHE_MODAL,
      payload: PersonensucheModal.UNFALL,
    };
  }

  openFremdvertragPersonensuche(): GlobalAction<PersonensucheModal> {
    return {
      type: GlobalActions.TOGGLE_PERSONENSUCHE_MODAL,
      payload: PersonensucheModal.FREMDVERTRAG,
    };
  }

  closePersonensucheModal(): GlobalAction<PersonensucheModal> {
    return {
      type: GlobalActions.TOGGLE_PERSONENSUCHE_MODAL,
      payload: PersonensucheModal.CLOSED,
    };
  }

  private withoutTransformation(responseData: unknown): unknown {
    return responseData;
  }

  vermittlernummerChanged(
    vermittlernummer: Vermittlernummer,
  ): GlobalAction<{ vermittlernummer: Vermittlernummer }> {
    return {
      type: GlobalActions.VERMITTLER_NUMMER_CHANGED,
      payload: { vermittlernummer: vermittlernummer },
    };
  }

  vermittlerBnrbChanged(bnrb: string): GlobalAction<{ bnrb: string }> {
    return {
      type: GlobalActions.VERMITTLER_BNRB_CHANGED,
      payload: { bnrb },
    };
  }

  vermittlerFremdChanged(fremd: boolean): GlobalAction<{ fremd: boolean }> {
    return {
      type: GlobalActions.VERMITTLER_FREMD_CHANGED,
      payload: { fremd },
    };
  }

  gegenstaendeCategoriesReceived(
    gegenstandCategories: GegenstandCategoryModel[],
  ): GlobalAction<GegenstandCategoryModel[]> {
    return {
      type: GlobalActions.GEGENSTAENDE_CATEGORIES_RECEIVED,
      payload: gegenstandCategories,
    };
  }

  updateAktionsNachlassCode(value: AktionsNachlass): GlobalAction<AktionsNachlass> {
    return {
      type: GlobalActions.UPDATE_AKTIONSNACHLASS_CODE,
      payload: value,
    };
  }

  checkValidityAktionsNachlassCode(): GlobalAction<void> {
    return {
      type: GlobalActions.CHECK_VALID_AKTIONSNACHLASS_CODE,
    };
  }

  assekuranzBeziehungChanged(payload: {
    angebotsId: AngebotsId['angebotsId'];
    beziehungZumVn: BeziehungZumVn;
  }): GlobalAction<{ angebotsId: AngebotsId['angebotsId']; beziehungZumVn: BeziehungZumVn }> {
    return {
      type: GlobalActions.ASSEKURANZ_BEZIEHUNG_CHANGED,
      payload,
    };
  }

  kooperationenListReceived(kooperationen: Kooperation[]): GlobalAction<Kooperation[]> {
    return {
      type: GlobalActions.KOOPERATIONEN_LIST_RECEIVED,
      payload: kooperationen,
    };
  }

  taasNachlassRabattReceived(
    taasNachlassVorteilReceivedPayload: TaasNachlassVorteilReceivedPayload,
  ): GlobalAction<TaasNachlassVorteilReceivedPayload> {
    return {
      type: GlobalActions.TAAS_NACHLASS_RABATT_RECEIVED,
      payload: taasNachlassVorteilReceivedPayload,
    };
  }

  zuschlagrisikoReceived(zuschlagRisikoForProduct: ZuschlagRisiko): GlobalAction<ZuschlagRisiko> {
    return {
      type: GlobalActions.ZUSCHLAGRISIKO_RECEIVED,
      payload: zuschlagRisikoForProduct,
    };
  }

  zuersZoneReceived(payload: {
    appId: App;
    angebotsId: string;
    zuersZone: string;
  }): GlobalAction<{ appId: App; angebotsId: string; zuersZone: string }> {
    return {
      type: GlobalActions.ZUERS_ZONE_RECEIVED,
      payload,
    };
  }

  zuschlaegeFaktorReceived(payload: {
    appId: App;
    angebotsId: string;
    zuschlaegeFaktor: number;
  }): GlobalAction<{ appId: App; angebotsId: string; zuschlaegeFaktor: number }> {
    return {
      type: GlobalActions.ZUSCHLAEGEFAKTOR_RECEIVED,
      payload,
    };
  }

  updateReceivedVorteilNachlass(): AnyAction {
    return { type: GlobalActions.UPDATE_RECEIVED_VORTEILNACHLASS };
  }

  internerVertragsbezugReceived(
    internerVertragsbezugs: string[],
    appId: App,
    angebotsId?: string,
  ): GlobalAction<{
    internerVertragsbezugs: string[];
    appId: App;
    angebotsId?: string;
  }> {
    return {
      type: GlobalActions.INTERNER_VERTRAGSBEZUG_RECEIVED,
      payload: {
        internerVertragsbezugs,
        appId,
        angebotsId,
      },
    };
  }

  updateRisikoortZuerszone(
    zuerszone?: number,
    angebotsId?: string,
  ): GlobalAction<{
    zuerszone?: number;
    angebotsId?: string;
  }> {
    return {
      type: GlobalActions.UPDATE_RISIKOORT_ZUERSZONE,
      payload: { zuerszone, angebotsId },
    };
  }

  setUnderwriterInfo(
    angebotsId?: string,
    requiredByContext?: Partial<Record<UwContextKey, boolean>>,
    promoteOnly?: boolean,
  ): GlobalAction<SetUnderwriterInfoPayload> {
    return {
      type: GlobalActions.SET_UNDERWRITER_INFO,
      payload: {
        angebotsId,
        requiredByContext,
        promoteOnly,
      },
    };
  }

  setAnfragepflichtigeInformationen(isAnfragepflichtigeInformationen: boolean): GlobalAction<{
    isAnfragepflichtigeInformationen: boolean;
  }> {
    return {
      type: GlobalActions.SET_ANFRAGEPFLICHTIGE_INFORMATIONEN,
      payload: { isAnfragepflichtigeInformationen },
    };
  }

  setShowTransferToAgentPage(
    showTransferToAgentPage: boolean,
  ): GlobalAction<{ showTransferToAgentPage: boolean }> {
    return {
      type: GlobalActions.SET_SHOW_TRANSFER_TO_AGENT_PAGE,
      payload: { showTransferToAgentPage },
    };
  }

  setEditingUwApprovedOffer(
    isEditingUwApprovedOffer: boolean,
  ): GlobalAction<{ isEditingUwApprovedOffer: boolean }> {
    return {
      type: GlobalActions.SET_EDITING_UW_APPROVED_OFFER,
      payload: { isEditingUwApprovedOffer },
    };
  }

  setNeedsUwResubmission(
    needsResubmission: boolean,
    angebotsId: string,
    requiredByContext?: Partial<Record<UwContextKey, boolean>>,
  ): GlobalAction<{
    needsResubmission: boolean;
    angebotsId: string;
    requiredByContext?: Partial<Record<UwContextKey, boolean>>;
  }> {
    return {
      type: GlobalActions.SET_NEEDS_UW_RESUBMISSION,
      payload: { needsResubmission, angebotsId, requiredByContext },
    };
  }

  uwResubmissionFulfilledAngeboteCollected(
    angebotsIds: Array<string>,
    triggeringAppId?: App,
    triggeringAngebotsId?: string,
    requiredByContext?: Partial<Record<UwContextKey, boolean>>,
  ): GlobalAction<{
    angebotsIds: Array<string>;
    triggeringAppId?: App;
    triggeringAngebotsId?: string;
    requiredByContext?: Partial<Record<UwContextKey, boolean>>;
  }> {
    return {
      type: GlobalActions.UW_RESUBMISSION_FULFILLED_ANGEBOTE_COLLECTED,
      payload: { angebotsIds, triggeringAppId, triggeringAngebotsId, requiredByContext },
    };
  }

  confirmUwApprovedOfferEdition(
    appId: App,
    angebotsId: string,
  ): GlobalAction<{ appId: App; angebotsId: string }> {
    return {
      type: GlobalActions.CONFIRM_UW_APPROVED_OFFER_EDITION,
      payload: { appId, angebotsId },
    };
  }

  setUwReviewBlocksEditing(
    uwReviewBlocksEditing: boolean,
  ): GlobalAction<{ uwReviewBlocksEditing: boolean }> {
    return {
      type: GlobalActions.SET_UW_REVIEW_BLOCKS_EDITING,
      payload: { uwReviewBlocksEditing },
    };
  }

  vhvV2einzelwerteChanged(
    einzelwerte: VhvV2XHoechsteEinzelwertePayload,
    angebotsId: string,
  ): GlobalAction<{
    einzelwerte: VhvV2XHoechsteEinzelwertePayload;
    angebotsId: string;
  }> {
    return {
      type: GlobalActions.EINZELWERTE_CHANGED,
      payload: {
        einzelwerte,
        angebotsId,
      },
    };
  }
}


export type TarifiereAngebotForShopAction = GlobalAction<AngebotsId>;
export type UpdateBeginnAblaufAction = GlobalAction<UpdateBeginnAblaufPayload>;
export type UpdateAngebotsDatumAction = GlobalAction<UpdateAngebotsDatumPayload>;
export type UpdateBeginnAblaufPayload = AngebotsId & { beginn?: string };
export type UpdateAngebotsDatumPayload = AngebotsId & { angebotsdatum?: string };
export type VorversicherungVorhandenChangedAction = GlobalAction<VorversicherungChanged>;
export type AddProduktToAngebotAction = GlobalAction<OwnedAngebotsId>;
export type ProvideStoreCreationDataAction = GlobalAction<ProvideStoreCreationDataPayload>;
export type ProvideVermittlernummerAction = GlobalAction<string>;

// Darüber würde ich gerne reden
const _globalActions = new GlobalActions();
export type GlobalFeatureToggleReceivedAction = ReturnType<
  typeof _globalActions.featuretoggleReceived
>;
export type GlobalRegexReceivedAction = ReturnType<typeof _globalActions.regexpsReceived>;
export type GlobalUnfallVpUebernehmenAction = ReturnType<typeof _globalActions.unfallVpUebernehmen>;
export type GlobalRoleDeterminedAction = ReturnType<typeof _globalActions.roleDetermined>;

export type GlobalVorversicherungVorhandenChangedAction = ReturnType<
  typeof _globalActions.vorversicherungVorhandenChanged
>;
export type GlobalVereinbarungenChangedAction = ReturnType<
  typeof _globalActions.vereinbarungenChanged
>;
export type GlobalAngebotsIdReceivedAction = ReturnType<typeof _globalActions.angebotsIdReceived>;
export type GlobalVertragslaufzeitChangedAction = ReturnType<
  typeof _globalActions.vertragslaufzeitAusgewaehlt
>;
export type GlobalGesamtbeitragChangedAction = ReturnType<typeof _globalActions.gesamtpreisChanged>;
export type GlobalCommonInsuranceDataReceivedAction = ReturnType<
  typeof _globalActions.commonInsuranceDataReceived
>;
export type GlobalProduktdAction = ReturnType<typeof _globalActions.produktAction>;
export type GlobalDeleteProduktdAction = ReturnType<typeof _globalActions.produktDeleted>;
export type GlobalProduktReceivedAction = ReturnType<typeof _globalActions.produktReceived>;
export type GlobalVermittlernummerChangeddAction = ReturnType<
  typeof _globalActions.vermittlernummerChanged
>;
export type GlobalVermittlerBnrBChangedAction = ReturnType<
  typeof _globalActions.vermittlerBnrbChanged
>;
export type GlobalFremdvermittlerChangedAction = ReturnType<
  typeof _globalActions.vermittlerFremdChanged
>;
export type GlobalVorbelegungForBeibehaltungRequestedAction = ReturnType<
  typeof _globalActions.vorbelegungForBeibehaltungRequested
>;
export type GlobalAssekuranzBeziehungChangedAction = ReturnType<
  typeof _globalActions.assekuranzBeziehungChanged
>;

export interface BeibehaltungProduktRequestedPayload {
  angebotsId: string;
  vorbelegungdaten: TkvV2Vorbelegungdaten | VwgV2Vorbelegungdaten | VhvV2Vorbelegungdaten;
}

export interface VhvV2XHoechsteEinzelwertePayload {
  hoechsterEinzelwertUhr?: number;
  hoechsterEinzelwertSchmuck?: number;
  hoechsterEinzelwertKunst?: number;
}
